import { Prop } from '../interfaces/prop.interface';

export const propsFoundJson: Prop[] = [
    {
        "id": "647ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "1: SALE 2:RENT 3:BOTH",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "242.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.68",
        "surfaceTotal": "242.68",
        "timeAvailableFrom": "9/13/22 13:22",
        "name": "Nombre del Local",
        "visible": true,
        "features": "Terrace, Parking space included, Storeroom, Good condition",
        "highLights": "Incluidas 90 plazas de aparcamiento en el precio, Edificio exclusivo en parque empresarial, Rápido acceso a A-1, M-40, M-50 y R-2",
        "descShort": "Descripción corta",
        "descLong": "Descripción larga",
        "comment": "¡En oferta!",
        "address": " Torras Y Bages 51 ",
        "postalCode": "08030",
        "lat": 41.4387768,
        "lng": 2.1908719
    },
    {
        "id": "a47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1137046",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "146.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "219.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.25",
        "surfaceTotal": "365.62",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza Puerta De Ávila 18 ",
        "postalCode": "37700",
        "lat": 40.3858218,
        "lng": -5.7651022
    },
    {
        "id": "be7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136039",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "122.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.10",
        "surfaceTotal": "357.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Ramiranes 1 ",
        "postalCode": "36400",
        "lat": 42.16302839999999,
        "lng": -8.6215005
    },
    {
        "id": "aa7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123092",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "495.78",
        "surfaceMezzanine": "0.00",
        "surfacepb": "837.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "985.89",
        "surfaceTotal": "1332.94",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Corredera De San Fernando 28 ",
        "postalCode": "23400",
        "lat": 38.0114762,
        "lng": -3.3696754
    },
    {
        "id": "ca7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141038",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "300.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "300.00",
        "surfaceTotal": "300.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Morerillas 1 ",
        "postalCode": "41700",
        "lat": 37.2840388,
        "lng": -5.9215691
    },
    {
        "id": "c87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1110113",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "114.81",
        "surfaceMezzanine": "0.00",
        "surfacepb": "139.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.44",
        "surfaceTotal": "253.81",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Real 34 ",
        "postalCode": "10210",
        "lat": 39.4255605,
        "lng": -5.756129899999999
    },
    {
        "id": "ac7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117118",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "142.38",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "129.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "279.32",
        "surfaceTotal": "443.84",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Onze de Setembre 36 ",
        "postalCode": "17230",
        "lat": 41.8484713,
        "lng": 3.1283736
    },
    {
        "id": "f07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.52",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.52",
        "surfaceTotal": "134.52",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Pedro Aleixandre 25 ",
        "postalCode": "46006",
        "lat": 39.4605843,
        "lng": -0.3627177
    },
    {
        "id": "087de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "106.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "60.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "166.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Jabonería 53 ",
        "postalCode": "28921",
        "lat": 40.3493006,
        "lng": -3.824473
    },
    {
        "id": "ea7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133024",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.50",
        "surfaceTotal": "143.50",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Constitución 19 ",
        "postalCode": "33208",
        "lat": 43.5363433,
        "lng": -5.6661481
    },
    {
        "id": "a87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123002",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.45",
        "surfaceTotal": "164.45",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Vera Cruz 2 ",
        "postalCode": "23680",
        "lat": 37.4631074,
        "lng": -3.923405299999999
    },
    {
        "id": "c47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "165.00",
        "surfaceTotal": "165.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Travessera De Las Corts 3 ",
        "postalCode": "08028",
        "lat": 41.3760775,
        "lng": 2.1179829
    },
    {
        "id": "c67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.13",
        "surfaceBasement1": "144.13",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "144.13",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "216.20",
        "surfaceTotal": "288.26",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Antón 23 ",
        "postalCode": "30004",
        "lat": 37.9908454,
        "lng": -1.1407818
    },
    {
        "id": "de7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.57",
        "surfaceTotal": "162.57",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Paraguay 2 ",
        "postalCode": "01012",
        "lat": 42.8566533,
        "lng": -2.678294
    },
    {
        "id": "e27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128092",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.00",
        "surfaceTotal": "255.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Baleares ",
        "postalCode": "28937",
        "lat": 40.3243561,
        "lng": -3.8563625
    },
    {
        "id": "f27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "175.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.50",
        "surfaceTotal": "373.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Madrid 191 ",
        "postalCode": "50017",
        "lat": 41.6524632,
        "lng": -0.9082194000000001
    },
    {
        "id": "d47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108169",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "235.03",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.03",
        "surfaceTotal": "235.03",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza Villa 2 ",
        "lat": 41.3245953,
        "lng": 2.0934902
    },
    {
        "id": "067de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.41",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.41",
        "surfaceTotal": "157.41",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Mármol 10 ",
        "postalCode": "28850",
        "lat": 40.4494564,
        "lng": -3.4686378
    },
    {
        "id": "b87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1138023",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "356.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "161.47",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "436.84",
        "surfaceTotal": "517.57",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Herradores 47 ",
        "postalCode": "38201",
        "lat": 28.4880088,
        "lng": -16.3168674
    },
    {
        "id": "ba7ce90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1121013",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Real 2 ",
        "lat": 37.3366246,
        "lng": -6.5362477
    },
    {
        "id": "ec7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "173.81",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.49",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.63",
        "surfaceTotal": "359.30",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Goya 77 ",
        "postalCode": "28001",
        "lat": 40.4250704,
        "lng": -3.678411
    },
    {
        "id": "fe7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1145168",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "190.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.18",
        "surfaceTotal": "381.82",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Ecuador 2 ",
        "postalCode": "45004",
        "lat": 39.8669882,
        "lng": -4.0294013
    },
    {
        "id": "3c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131105",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Carnicerias 2 ",
        "postalCode": "31593",
        "lat": 42.056272,
        "lng": -1.8589985
    },
    {
        "id": "d87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.00",
        "surfaceTotal": "151.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Sancho Sancho El Sabio 33 ",
        "postalCode": "20010",
        "lat": 43.308237,
        "lng": -1.9794923
    },
    {
        "id": "247de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "155.31",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.90",
        "surfaceTotal": "310.62",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Constitución 15 ",
        "postalCode": "18001",
        "lat": 37.18391630000001,
        "lng": -3.6044879
    },
    {
        "id": "e67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "245.16",
        "surfaceTotal": "245.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Travesía Bayona 1 ",
        "postalCode": "31011",
        "lat": 42.8142918,
        "lng": -1.6581462
    },
    {
        "id": "2a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108113",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "148.63",
        "surfaceMezzanine": "0.00",
        "surfacepb": "204.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "249.29",
        "surfaceTotal": "353.33",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Borne 36 ",
        "postalCode": "08240",
        "lat": 41.72509540000001,
        "lng": 1.8243723
    },
    {
        "id": "1a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125040",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "277.76",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "182.76",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "355.59",
        "surfaceTotal": "641.40",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza Mercadal C/V Mayor ",
        "postalCode": "25600",
        "lat": 41.7897376,
        "lng": 0.8052786
    },
    {
        "id": "447de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "75.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.42",
        "surfaceTotal": "251.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Vía Augusta 81 ",
        "postalCode": "08006",
        "lat": 41.4007095,
        "lng": 2.1502226
    },
    {
        "id": "107de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "139.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "310.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "351.90",
        "surfaceTotal": "449.48",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Costa Rica 9 ",
        "postalCode": "28005",
        "lat": 40.4588807,
        "lng": -3.6750384
    },
    {
        "id": "7a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.04",
        "surfaceTotal": "84.04",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Rioja 8 ",
        "postalCode": "28915",
        "lat": 40.3341964,
        "lng": -3.756238599999999
    },
    {
        "id": "f67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "219.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.34",
        "surfaceTotal": "219.34",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Tomás Ortuño 83 ",
        "postalCode": "03500",
        "lat": 38.54158,
        "lng": -0.13209
    },
    {
        "id": "9e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108180",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "132.60",
        "surfaceMezzanine": "0.00",
        "surfacepb": "288.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "198.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "426.78",
        "surfaceTotal": "618.60",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Del Padró 12 ",
        "postalCode": "08291",
        "lat": 41.4969245,
        "lng": 2.1547513
    },
    {
        "id": "427de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Equipamiento",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "410.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "410.00",
        "surfaceTotal": "410.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Santa Mónica 6 ",
        "postalCode": "08002",
        "lat": 41.3772716,
        "lng": 2.1750519
    },
    {
        "id": "307de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130043",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "208.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "450.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "512.40",
        "surfaceTotal": "658.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle San Francisco 4 ",
        "postalCode": "30510",
        "lat": 38.6138891,
        "lng": -1.115255
    },
    {
        "id": "3a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125122",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "105.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "105.95",
        "surfaceTotal": "105.95",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Pons I Ariola, 10 ",
        "postalCode": "25240",
        "lat": 41.7102995,
        "lng": 0.9024835999999999
    },
    {
        "id": "767de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1109219",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "295.54",
        "surfaceMezzanine": "0.00",
        "surfacepb": "295.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "384.20",
        "surfaceTotal": "591.08",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Estación 58 ",
        "postalCode": "09200",
        "lat": 42.68819200000001,
        "lng": -2.9430187
    },
    {
        "id": "667de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Emperador Carlos V 1 ",
        "postalCode": "50009",
        "lat": 41.6379994,
        "lng": -0.8981281
    },
    {
        "id": "4a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1103122",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "49.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "111.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "267.02",
        "surfaceTotal": "357.02",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Libertad 26 ",
        "postalCode": "03690",
        "lat": 38.3972278,
        "lng": -0.522645
    },
    {
        "id": "727de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "234.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.24",
        "surfaceTotal": "234.24",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Zaragoza 11 ",
        "postalCode": "31003",
        "lat": 42.8110955,
        "lng": -1.6432708
    },
    {
        "id": "827de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.50",
        "surfaceTotal": "152.50",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Aribau 249 ",
        "postalCode": "08021",
        "lat": 41.3984354,
        "lng": 2.146508
    },
    {
        "id": "da7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "248.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.20",
        "surfaceTotal": "248.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Cea Bermudez 25-27 ",
        "postalCode": "28003",
        "lat": 40.438726,
        "lng": -3.7102691
    },
    {
        "id": "127de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128106",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "266.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.00",
        "surfaceTotal": "266.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Pinto ",
        "postalCode": "28980",
        "lat": 40.2375052,
        "lng": -3.6967718
    },
    {
        "id": "a87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "62.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.85",
        "surfaceTotal": "192.05",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Batllori 7 ",
        "postalCode": "08031",
        "lat": 41.4433249,
        "lng": 2.1778586
    },
    {
        "id": "d87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": false,
        "surfacebr": "166.48",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.34",
        "surfaceTotal": "308.52",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Carretas 14 ",
        "postalCode": "28012",
        "lat": 40.4148114,
        "lng": -3.7036534
    },
    {
        "id": "a07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "297.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "297.94",
        "surfaceTotal": "297.94",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Caspe 70 ",
        "postalCode": "08010",
        "lat": 41.3922598,
        "lng": 2.1749557
    },
    {
        "id": "0e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Doctor Loureiro Crespo 20 ",
        "postalCode": "36004",
        "lat": 42.4283935,
        "lng": -8.6350368
    },
    {
        "id": "207ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1132054",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.14",
        "surfaceTotal": "164.14",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Ervedelo 37 ",
        "lat": 42.3399301,
        "lng": -7.8717774
    },
    {
        "id": "6e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "165.74",
        "surfaceTotal": "165.74",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Oceano Atlantico 3 ",
        "postalCode": "28820",
        "lat": 40.4186786,
        "lng": -3.5698007
    },
    {
        "id": "467de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "389.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "389.24",
        "surfaceTotal": "389.24",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Marqués De Sentmenat 44 ",
        "postalCode": "08014",
        "lat": 41.3848427,
        "lng": 2.1369888
    },
    {
        "id": "547de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "88.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "207.40",
        "surfaceTotal": "269.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Peña Prieta 57 ",
        "postalCode": "28038",
        "lat": 40.4023244,
        "lng": -3.6644507
    },
    {
        "id": "347ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.37",
        "surfaceTotal": "132.37",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Ezequiel Solana 97 ",
        "postalCode": "28017",
        "lat": 40.4273974,
        "lng": -3.6420678
    },
    {
        "id": "967de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "87.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.10",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Julio Antonio 1 ",
        "postalCode": "28025",
        "lat": 40.3827965,
        "lng": -3.7301068
    },
    {
        "id": "d27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148082",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "30.88",
        "surfaceMezzanine": "0.00",
        "surfacepb": "211.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.54",
        "surfaceTotal": "242.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Capitán Mendizábal 8 ",
        "postalCode": "48980",
        "lat": 43.3312004,
        "lng": -3.0333872
    },
    {
        "id": "2c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "188.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.91",
        "surfaceTotal": "188.91",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Marques De Paradas 26 ",
        "postalCode": "41001",
        "lat": 37.3896996,
        "lng": -6.0011975
    },
    {
        "id": "f87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "75.00",
        "surfacepb": "118.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "75.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.50",
        "surfaceTotal": "193.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Usandizaga 29 ",
        "postalCode": "20002",
        "lat": 43.3244951,
        "lng": -1.9754999
    },
    {
        "id": "1e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.21",
        "surfaceTotal": "144.21",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo General Dávila ",
        "postalCode": "39007",
        "lat": 43.4673632,
        "lng": -3.8082696
    },
    {
        "id": "bc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1138660",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "56.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.80",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Rafael Puig s/n ",
        "postalCode": "38670",
        "lat": 28.0618615,
        "lng": -16.7312336
    },
    {
        "id": "dc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "83.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "57.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "168.40",
        "surfaceTotal": "255.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Miguel Angel 3 ",
        "postalCode": "28010",
        "lat": 40.4338658,
        "lng": -3.6916067
    },
    {
        "id": "5a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.73",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.73",
        "surfaceTotal": "171.73",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Retuerto 60 ",
        "postalCode": "48903",
        "lat": 43.2887919,
        "lng": -3.0081977
    },
    {
        "id": "d27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108205",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.77",
        "surfaceTotal": "189.77",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Can Mora 7 ",
        "postalCode": "08190",
        "lat": 41.46835,
        "lng": 2.08287
    },
    {
        "id": "207de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.25",
        "surfaceTotal": "161.25",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Autonomía 20 ",
        "postalCode": "48012",
        "lat": 43.2575487,
        "lng": -2.9376287
    },
    {
        "id": "1e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "44.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "44.00",
        "surfaceTotal": "44.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Mallorca 547 ",
        "lat": 41.409747,
        "lng": 2.1835645
    },
    {
        "id": "e47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.63",
        "surfaceTotal": "198.63",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Gava 62 ",
        "postalCode": "08014",
        "lat": 41.3709922,
        "lng": 2.139250800000001
    },
    {
        "id": "ca7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128065",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.00",
        "surfaceTotal": "146.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Cervantes 14 ",
        "postalCode": "28904",
        "lat": 40.3046381,
        "lng": -3.7364753
    },
    {
        "id": "fa7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": true,
        "surfacebr": "221.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "376.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "442.30",
        "surfaceTotal": "597.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle O'Donnell 23 ",
        "postalCode": "28005",
        "lat": 40.421788,
        "lng": -3.6777797
    },
    {
        "id": "287de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114038",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "324.35",
        "surfaceTotal": "324.35",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Agua 2 ",
        "postalCode": "14900",
        "lat": 37.4086756,
        "lng": -4.4876616
    },
    {
        "id": "b07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "97.38",
        "surfaceMezzanine": "0.00",
        "surfacepb": "75.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.83",
        "surfaceTotal": "173.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Santa Susana 27 ",
        "postalCode": "28033",
        "lat": 40.477192,
        "lng": -3.6462847
    },
    {
        "id": "3e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125021",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.18",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.18",
        "surfaceTotal": "153.18",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " L'Horta 11 ",
        "postalCode": "25126",
        "lat": 41.7970523,
        "lng": 0.5680948
    },
    {
        "id": "b47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.90",
        "surfaceTotal": "189.90",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Doctor Areilza 26 ",
        "postalCode": "48011",
        "lat": 43.2620432,
        "lng": -2.9424527
    },
    {
        "id": "927de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1105016",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "119.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.50",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.10",
        "surfaceTotal": "358.50",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Caldereros 6 ",
        "postalCode": "05200",
        "lat": 41.0626779,
        "lng": -4.719558999999999
    },
    {
        "id": "ba7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Vitoria 141 ",
        "postalCode": "09007",
        "lat": 42.3504045,
        "lng": -3.6747213
    },
    {
        "id": "807de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "183.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "183.15",
        "surfaceTotal": "183.15",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Camino De Vinateros 63 ",
        "postalCode": "28030",
        "lat": 40.4104247,
        "lng": -3.6519351
    },
    {
        "id": "be7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130016",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "229.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.85",
        "surfaceTotal": "229.70",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Aire 21 ",
        "lat": 37.6004379,
        "lng": -0.9856703999999998
    },
    {
        "id": "ae7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "129.42",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.15",
        "surfaceTotal": "257.74",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Manuel Girona 12 ",
        "postalCode": "08034",
        "lat": 41.3898955,
        "lng": 2.1209755
    },
    {
        "id": "0e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "217.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "273.10",
        "surfaceTotal": "425.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle San Pedro De Mezonzo 3 ",
        "postalCode": "15705",
        "lat": 42.8740523,
        "lng": -8.548798099999999
    },
    {
        "id": "aa7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "48.59",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.43",
        "surfaceTotal": "145.44",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Vía Augusta 264 ",
        "postalCode": "08017",
        "lat": 41.3980003,
        "lng": 2.1325794
    },
    {
        "id": "ac7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.80",
        "surfaceTotal": "155.80",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Balmes 423 ",
        "postalCode": "08022",
        "lat": 41.4081853,
        "lng": 2.1377393
    },
    {
        "id": "9c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "148.85",
        "surfaceMezzanine": "0.00",
        "surfacepb": "165.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "210.59",
        "surfaceTotal": "314.78",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Arenal 19 ",
        "postalCode": "28013",
        "lat": 40.4175537,
        "lng": -3.708034
    },
    {
        "id": "167ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130035",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "131.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.14",
        "surfaceTotal": "295.40",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Carretera Cartagena-Alicante ",
        "postalCode": "30730",
        "lat": 38.3459963,
        "lng": -0.4906855
    },
    {
        "id": "d47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.28",
        "surfaceTotal": "120.28",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Lagasca 13 ",
        "postalCode": "28001",
        "lat": 40.422172,
        "lng": -3.6858377
    },
    {
        "id": "2a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "109.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.00",
        "surfaceTotal": "109.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza De Fornells 23 ",
        "postalCode": "08033",
        "lat": 40.05714469999999,
        "lng": 4.1302671
    },
    {
        "id": "267ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1111012",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.10",
        "surfaceTotal": "96.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Ana De Viya 54 ",
        "postalCode": "11009",
        "lat": 36.5081718,
        "lng": -6.2782073
    },
    {
        "id": "ea7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "433.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "35.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "451.19",
        "surfaceTotal": "468.69",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza Emilio Díaz De Revenga 1 ",
        "postalCode": "30008",
        "lat": 37.9911078,
        "lng": -1.134886
    },
    {
        "id": "cc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "74.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "92.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.81",
        "surfaceTotal": "166.76",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Pozo 1 ",
        "postalCode": "24003",
        "lat": 21.1250077,
        "lng": -101.6859605
    },
    {
        "id": "c87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.20",
        "surfaceTotal": "160.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Tomas Morales 83 ",
        "postalCode": "35004",
        "lat": 28.1162089,
        "lng": -15.4262567
    },
    {
        "id": "d67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "188.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "450.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "453.40",
        "surfaceTotal": "810.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza Cascorro 23 ",
        "postalCode": "28005",
        "lat": 40.4113063,
        "lng": -3.7073651
    },
    {
        "id": "2e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1138650",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "163.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.27",
        "surfaceTotal": "284.54",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De Los Playeros ",
        "postalCode": "38650",
        "lat": 28.0503209,
        "lng": -16.7177511
    },
    {
        "id": "1c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108187",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "108.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.00",
        "surfaceTotal": "108.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Francesc Layret 13 ",
        "postalCode": "08208",
        "lat": 41.5591403,
        "lng": 2.0979741
    },
    {
        "id": "047ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1112135",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "301.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "357.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "479.60",
        "surfaceTotal": "658.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza Bayarri 6 ",
        "postalCode": "12540",
        "lat": 39.9388215,
        "lng": -0.0992884
    },
    {
        "id": "067ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.70",
        "surfaceTotal": "154.70",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Gran Via 46- 48 ",
        "postalCode": "50005",
        "lat": 41.6449633,
        "lng": -0.8914605
    },
    {
        "id": "0a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "10.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.00",
        "surfaceTotal": "10.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Miraflores 105 ",
        "postalCode": "08905",
        "lat": 41.372552,
        "lng": 2.1065599
    },
    {
        "id": "fc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.00",
        "surfaceTotal": "166.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle begoñalde 3 ",
        "postalCode": "48007",
        "lat": 43.2534399,
        "lng": -2.9016656
    },
    {
        "id": "ce7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146145",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.00",
        "surfaceTotal": "193.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida República Argentina 1 ",
        "lat": 38.990317,
        "lng": -0.5229710000000001
    },
    {
        "id": "027ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135019",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "117.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.20",
        "surfaceTotal": "117.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Italia 18 ",
        "postalCode": "35100",
        "lat": 27.7602316,
        "lng": -15.5681384
    },
    {
        "id": "307ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1137274",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Estacion 42401 ",
        "postalCode": "37003",
        "lat": 40.9707287,
        "lng": -5.6522982
    },
    {
        "id": "d07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125120",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.25",
        "surfaceTotal": "113.25",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Prat De La Riva 29 ",
        "postalCode": "25008",
        "lat": 41.620752,
        "lng": 0.6229604999999999
    },
    {
        "id": "f67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "110.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "85.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.00",
        "surfaceTotal": "195.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Olmos 18 ",
        "postalCode": "20016",
        "lat": 43.3204706,
        "lng": -1.9407086
    },
    {
        "id": "3a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135034",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "131.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.00",
        "surfaceTotal": "131.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Limones SN ",
        "postalCode": "35570",
        "lat": 28.9568368,
        "lng": -13.7984428
    },
    {
        "id": "587ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Mejía Lequerica 16 ",
        "postalCode": "28004",
        "lat": 40.42742570000001,
        "lng": -3.6989164
    },
    {
        "id": "427ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "242.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.45",
        "surfaceTotal": "242.45",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Doctor J.J. Domine 14 ",
        "postalCode": "46011",
        "lat": 39.46217499999999,
        "lng": -0.331273
    },
    {
        "id": "447ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "84.37",
        "surfaceMezzanine": "0.00",
        "surfacepb": "69.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "28.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.11",
        "surfaceTotal": "182.54",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Rodriguez San Pedro 8 ",
        "postalCode": "28015",
        "lat": 40.4316576,
        "lng": -3.7067561
    },
    {
        "id": "007fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "129.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.78",
        "surfaceTotal": "255.48",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Ramiro I ",
        "postalCode": "33012",
        "lat": 43.3650111,
        "lng": -5.860415
    },
    {
        "id": "767ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.36",
        "surfaceTotal": "118.36",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Txomin Garat, 7 ",
        "postalCode": "48004",
        "lat": 43.257711,
        "lng": -2.9087168
    },
    {
        "id": "487ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Carretera De Canillas 21 ",
        "postalCode": "28043",
        "lat": 40.4630331,
        "lng": -3.650125
    },
    {
        "id": "5e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.30",
        "surfaceTotal": "126.30",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Valdelasierra 10 ",
        "postalCode": "28005",
        "lat": 40.3975692,
        "lng": -3.7048242
    },
    {
        "id": "707ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "184.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "184.33",
        "surfaceTotal": "184.33",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Amador D. Rios 48-50 ",
        "postalCode": "41003",
        "lat": 37.3921393,
        "lng": -5.982257499999999
    },
    {
        "id": "b07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1101017",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "90.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "109.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza samuel picazo 3 ",
        "postalCode": "01110",
        "lat": 42.69332379999999,
        "lng": -2.3517526
    },
    {
        "id": "247ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.95",
        "surfaceTotal": "170.95",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Gran Via Carles III 94 ",
        "postalCode": "08028",
        "lat": 41.38617199999999,
        "lng": 2.1277248
    },
    {
        "id": "527ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "207.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.21",
        "surfaceTotal": "344.46",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Doctor Fleming 16 ",
        "postalCode": "28036",
        "lat": 40.4557361,
        "lng": -3.6881744
    },
    {
        "id": "3c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1138038",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "70.15",
        "surfaceMezzanine": "0.00",
        "surfacepb": "109.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.05",
        "surfaceTotal": "179.15",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Eric Lionel Fox 3 ",
        "postalCode": "38005",
        "lat": 28.4598826,
        "lng": -16.2628562
    },
    {
        "id": "887ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1113082",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.00",
        "surfaceTotal": "111.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Antonio Huertas 149 ",
        "lat": 39.1522653,
        "lng": -3.0132667
    },
    {
        "id": "ee7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "179.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "360.00",
        "surfaceBasement1": "358.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "358.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "592.70",
        "surfaceTotal": "897.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Michelena 26 ",
        "postalCode": "36002",
        "lat": 42.431316,
        "lng": -8.6456312
    },
    {
        "id": "8c82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1133980",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "103.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "51.50",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " La Libertad 24 ",
        "lat": 43.2450108,
        "lng": -5.561657299999999
    },
    {
        "id": "807ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129070",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.00",
        "surfaceBasement1": "178.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "178.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "267.00",
        "surfaceTotal": "356.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle De De La Cala ",
        "postalCode": "29649",
        "lat": 36.504559,
        "lng": -4.679652
    },
    {
        "id": "387ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1138660",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "54.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "215.54",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.97",
        "surfaceTotal": "269.54",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Urbanización San Eugenio ",
        "postalCode": "38660",
        "lat": 28.0613928,
        "lng": -16.7267975
    },
    {
        "id": "5c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "105.51",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "80.26",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "216.20",
        "surfaceTotal": "330.19",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Sant Miquel 51 ",
        "postalCode": "07002",
        "lat": 39.57417299999999,
        "lng": 2.6520591
    },
    {
        "id": "547ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.48",
        "surfaceTotal": "147.48",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Numancia 6 ",
        "postalCode": "28039",
        "lat": 40.4541213,
        "lng": -3.712296
    },
    {
        "id": "467ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128005",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "179.71",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.57",
        "surfaceTotal": "325.37",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Juan De Austria, 32 ",
        "postalCode": "28804",
        "lat": 40.4871697,
        "lng": -3.3508794
    },
    {
        "id": "2280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1129038",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.29",
        "surfaceTotal": "124.29",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Andalucia 31 ",
        "postalCode": "29570",
        "lat": 36.7363451,
        "lng": -4.6057597
    },
    {
        "id": "bc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146078",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.00",
        "surfaceTotal": "215.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza emilio castelar 5 ",
        "postalCode": "46100",
        "lat": 39.5089007,
        "lng": -0.4105484
    },
    {
        "id": "627ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "53.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "211.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.82",
        "surfaceTotal": "265.48",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza De La Inmaculada 7 ",
        "postalCode": "24001",
        "lat": 42.6000032,
        "lng": -5.575819699999999
    },
    {
        "id": "dc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148019",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.00",
        "surfaceTotal": "194.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle iturriza ",
        "postalCode": "48240",
        "lat": 43.1758507,
        "lng": -2.5768462
    },
    {
        "id": "847ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1110148",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.05",
        "surfaceTotal": "186.05",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Sor Valentina Mirón 82 ",
        "postalCode": "10600",
        "lat": 40.0338622,
        "lng": -6.0881721
    },
    {
        "id": "367ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.50",
        "surfaceTotal": "107.50",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Sancho El Fuerte 24 ",
        "postalCode": "31007",
        "lat": 42.8104527,
        "lng": -1.6561444
    },
    {
        "id": "d07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "67.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.10",
        "surfaceTotal": "267.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle borbolla 13 ",
        "postalCode": "41004",
        "lat": 37.37660109999999,
        "lng": -5.9843195
    },
    {
        "id": "ea7ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1115057",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "130.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "235.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.50",
        "surfaceTotal": "495.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Rua De Galicia 10 ",
        "lat": 42.7841592,
        "lng": -8.887869799999999
    },
    {
        "id": "007de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "154.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Burjasot 33 ",
        "postalCode": "46002",
        "lat": 39.4847945,
        "lng": -0.3853197
    },
    {
        "id": "cc7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "119.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.70",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Gran de la Sagrera 158 ",
        "postalCode": "08027",
        "lat": 41.4252865,
        "lng": 2.1912217
    },
    {
        "id": "6a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Vista Alegre 5 ",
        "postalCode": "39001",
        "lat": 43.4645032,
        "lng": -3.8103025
    },
    {
        "id": "4c81e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1116067",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "142.48",
        "surfaceTotal": "142.48",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza DeEspaña 19 ",
        "lat": 42.1711903,
        "lng": -1.6905154
    },
    {
        "id": "a47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.00",
        "surfaceTotal": "202.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Valencia 617 ",
        "lat": 41.4100841,
        "lng": 2.1862596
    },
    {
        "id": "507de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115019",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.00",
        "surfaceTotal": "250.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle vázquez de parga 5 ",
        "postalCode": "15100",
        "lat": 43.2139603,
        "lng": -8.690708599999999
    },
    {
        "id": "027de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108298",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "93.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "93.00",
        "surfaceTotal": "93.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Paseo generalitat 18 ",
        "postalCode": "08500",
        "lat": 41.9237093,
        "lng": 2.2532019
    },
    {
        "id": "367de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "123.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.90",
        "surfaceTotal": "263.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle rodrigo rebolledo 36 ",
        "postalCode": "50002",
        "lat": 41.6458315,
        "lng": -0.862095
    },
    {
        "id": "ae7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148060",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "73.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "73.00",
        "surfaceTotal": "73.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza goiko portala 4 ",
        "postalCode": "48270",
        "lat": 43.2674969,
        "lng": -2.4981302
    },
    {
        "id": "567ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "36.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.14",
        "surfaceTotal": "112.34",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Claret 10 ",
        "postalCode": "28002",
        "lat": 40.4477974,
        "lng": -3.6641263
    },
    {
        "id": "567de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle peñón 5 ",
        "postalCode": "28923",
        "lat": 40.3481177,
        "lng": -3.8197588
    },
    {
        "id": "c27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1103009",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "175.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "3.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.00",
        "surfaceTotal": "386.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Alameda 8 ",
        "postalCode": "03803",
        "lat": 38.6990623,
        "lng": -0.480554
    },
    {
        "id": "587de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " san adrian 133 ",
        "postalCode": "08030",
        "lat": 41.436485,
        "lng": 2.2056452
    },
    {
        "id": "ee7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "250.00",
        "surfaceTotal": "250.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida pino montano 22 ",
        "postalCode": "41008",
        "lat": 37.4061633,
        "lng": -5.9743973
    },
    {
        "id": "527de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "91.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "91.00",
        "surfaceTotal": "91.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Villaviciosa 36 ",
        "postalCode": "28024",
        "lat": 40.397111,
        "lng": -3.7710345
    },
    {
        "id": "867de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "142.00",
        "surfaceTotal": "142.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " callao 42 ",
        "postalCode": "28945",
        "lat": 40.2930774,
        "lng": -3.785768
    },
    {
        "id": "187de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103014",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.00",
        "surfaceTotal": "153.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Holanda 10 ",
        "postalCode": "03540",
        "lat": 38.368408,
        "lng": -0.413914
    },
    {
        "id": "327de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1102035",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.00",
        "surfaceTotal": "124.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " real 67 ",
        "postalCode": "02110",
        "lat": 39.1132781,
        "lng": -1.9961056
    },
    {
        "id": "5c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Singladura 7 ",
        "postalCode": "07610",
        "lat": 39.5370107,
        "lng": 2.7174493
    },
    {
        "id": "5e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107033",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "136.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "258.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle mar 29 ",
        "postalCode": "07680",
        "lat": 39.54042760000001,
        "lng": 3.3330087
    },
    {
        "id": "707de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "215.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "39.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.50",
        "surfaceTotal": "254.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza trinidad 5 ",
        "postalCode": "08033",
        "lat": 41.4499891,
        "lng": 2.1912217
    },
    {
        "id": "da7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120034",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "68.00",
        "surfaceTotal": "68.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " santa ana 21 ",
        "postalCode": "20540",
        "lat": 43.0165575,
        "lng": -2.5278399
    },
    {
        "id": "b47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1106022",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza españa 27 ",
        "postalCode": "06370",
        "lat": 38.3820414,
        "lng": -6.590122
    },
    {
        "id": "7e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " navarra 16 ",
        "postalCode": "41015",
        "lat": 37.4226813,
        "lng": -5.983408799999999
    },
    {
        "id": "c67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120049",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.00",
        "surfaceTotal": "144.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " hirigoien 1 ",
        "postalCode": "20210",
        "lat": 43.0331475,
        "lng": -2.1863061
    },
    {
        "id": "5a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108200",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle j. rubio i orts o rosello 67 31 ",
        "postalCode": "08830",
        "lat": 41.3476725,
        "lng": 2.0288506
    },
    {
        "id": "947de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103093",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.00",
        "surfaceTotal": "126.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " alcalde manuel alberola 10 ",
        "postalCode": "03660",
        "lat": 38.3846539,
        "lng": -0.7653509
    },
    {
        "id": "907de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111010",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.00",
        "surfaceTotal": "132.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " San Jerónimo 20 ",
        "postalCode": "11640",
        "lat": 36.818063,
        "lng": -5.743377
    },
    {
        "id": "127ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131060",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "58.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.00",
        "surfaceTotal": "181.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " mayor 20 ",
        "postalCode": "31600",
        "lat": 42.8264759,
        "lng": -1.6156261
    },
    {
        "id": "1a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1139054",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.00",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " el piñal 15 ",
        "postalCode": "39313",
        "lat": 19.4340199,
        "lng": -99.19560120000001
    },
    {
        "id": "fe7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1134023",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.00",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida primero de junio 46 ",
        "postalCode": "34200",
        "lat": 41.9199746,
        "lng": -4.4966208
    },
    {
        "id": "ec7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115059",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "49.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "241.50",
        "surfaceTotal": "266.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " parque municipal 4 ",
        "postalCode": "15680",
        "lat": 43.0770613,
        "lng": -8.407864199999999
    },
    {
        "id": "b27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "128.00",
        "surfaceTotal": "128.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida de la Cañada 27 ",
        "postalCode": "11203",
        "lat": 40.42378009999999,
        "lng": -3.5367805
    },
    {
        "id": "b87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115058",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida ernesto che guevara 5 ",
        "postalCode": "15172",
        "lat": 43.3335162,
        "lng": -8.3789705
    },
    {
        "id": "047de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146131",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida república argentina 41 ",
        "postalCode": "46700",
        "lat": 38.9684123,
        "lng": -0.1857564
    },
    {
        "id": "507ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida hytasa 36 ",
        "postalCode": "41006",
        "lat": 37.3678965,
        "lng": -5.9556303
    },
    {
        "id": "147ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130016",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " castelar 7 ",
        "postalCode": "30366",
        "lat": 37.6899267,
        "lng": -0.9640312999999998
    },
    {
        "id": "7c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108245",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "21.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "89.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "95.30",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Mosen Jacinto Verdaguer 136 ",
        "postalCode": "08923",
        "lat": 41.4489328,
        "lng": 2.2178829
    },
    {
        "id": "6a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107042",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " juan xxiii 10 ",
        "postalCode": "07470",
        "lat": 39.8771939,
        "lng": 3.0162026
    },
    {
        "id": "007ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108281",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Riera 124 ",
        "postalCode": "08329",
        "lat": 41.4964205,
        "lng": 2.3218228
    },
    {
        "id": "667ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1142173",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo del espolon 24 ",
        "postalCode": "42001",
        "lat": 41.76509129999999,
        "lng": -2.4732812
    },
    {
        "id": "e082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "36.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "36.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "54.00",
        "surfaceTotal": "72.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle zaratán 2 ",
        "postalCode": "28037",
        "lat": 40.4281891,
        "lng": -3.6254782
    },
    {
        "id": "4a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108252",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Ronda industria 49 ",
        "postalCode": "08210",
        "lat": 41.5156583,
        "lng": 2.1296375
    },
    {
        "id": "d081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120045",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "49.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "14.70",
        "surfaceTotal": "49.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " renteria 1 ",
        "postalCode": "20301",
        "lat": 43.3081107,
        "lng": -1.8912823
    },
    {
        "id": "de82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "145.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.50",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " clunia 6 ",
        "postalCode": "09005",
        "lat": 42.3472308,
        "lng": -3.6955869
    },
    {
        "id": "287ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Travesía de les Corts 371 ",
        "postalCode": "08029",
        "lat": 41.390319,
        "lng": 2.1403804
    },
    {
        "id": "827ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida La Torrecilla 3 ",
        "postalCode": "14013",
        "lat": 37.861742,
        "lng": -4.7865772
    },
    {
        "id": "e07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146181",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "475.19",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "183.69",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "567.04",
        "surfaceTotal": "658.88",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Carretera de Gabriel Ciscar 1 ",
        "postalCode": "46780",
        "lat": 38.9187512,
        "lng": -0.1179521
    },
    {
        "id": "4c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1101021",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida coruña 9 ",
        "postalCode": "15189",
        "lat": 43.3161759,
        "lng": -8.3659383
    },
    {
        "id": "e87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1133900",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "111.25",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.88",
        "surfaceTotal": "222.50",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Carracido 4 ",
        "postalCode": "33900",
        "lat": 43.2959841,
        "lng": -5.683948
    },
    {
        "id": "687de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130008",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "134.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "108.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "108.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "134.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.20",
        "surfaceTotal": "353.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida juan carlos i 1 ",
        "postalCode": "30840",
        "lat": 37.8511809,
        "lng": -1.422888
    },
    {
        "id": "6c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "135.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "213.50",
        "surfaceTotal": "281.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida maria fortuny 40 ",
        "postalCode": "43201",
        "lat": 41.1567251,
        "lng": 1.1175964
    },
    {
        "id": "747ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "101.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "101.00",
        "surfaceTotal": "101.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle de tremp 31 ",
        "postalCode": "08032",
        "lat": 41.43852649999999,
        "lng": 2.1877948
    },
    {
        "id": "687ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Molini s/n ",
        "postalCode": "41012",
        "lat": 37.3989451,
        "lng": -5.9923181
    },
    {
        "id": "f87ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.77",
        "surfaceTotal": "88.77",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Marqués De Pontejos 4 ",
        "postalCode": "15001",
        "lat": 43.3720986,
        "lng": -8.3985708
    },
    {
        "id": "787ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "270.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "270.00",
        "surfaceTotal": "270.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " el hayedo 1 ",
        "postalCode": "24007",
        "lat": 42.6045555,
        "lng": -5.5625578
    },
    {
        "id": "4e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle juan dominguez perez 19 ",
        "postalCode": "35008",
        "lat": 28.1564841,
        "lng": -15.415821
    },
    {
        "id": "0c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133024",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "114.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.00",
        "surfaceTotal": "114.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " brasil 20 ",
        "postalCode": "33213",
        "lat": 43.5322015,
        "lng": -5.6611195
    },
    {
        "id": "0c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "64.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "356.00",
        "surfaceTotal": "388.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Doutor Teixeiro 20 ",
        "postalCode": "15701",
        "lat": 42.8747502,
        "lng": -8.545537
    },
    {
        "id": "ce7ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1132009",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.20",
        "surfaceTotal": "149.20",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Marcelino Suarez 12 ",
        "postalCode": "32300",
        "lat": 42.4161794,
        "lng": -6.9821789
    },
    {
        "id": "f47ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "9.02",
        "surfaceMezzanine": "0.00",
        "surfacepb": "548.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "550.86",
        "surfaceTotal": "557.17",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Enric Prat De La Riba 155 ",
        "postalCode": "08901",
        "lat": 41.3623892,
        "lng": 2.1089451
    },
    {
        "id": "0a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128130",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Pablo Picasso 7 ",
        "lat": 40.4258776,
        "lng": -3.5325333
    },
    {
        "id": "147de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "214.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "214.82",
        "surfaceTotal": "214.82",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Camino Del Magros 95 ",
        "postalCode": "03202",
        "lat": 38.2847647,
        "lng": -0.7089597
    },
    {
        "id": "387de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "241.93",
        "surfaceMezzanine": "0.00",
        "surfacepb": "257.07",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "329.65",
        "surfaceTotal": "499.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Coso 102 ",
        "postalCode": "50001",
        "lat": 41.6506587,
        "lng": -0.8768323
    },
    {
        "id": "787de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.45",
        "surfaceTotal": "180.45",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Esperanza de Triana 41 ",
        "postalCode": "41010",
        "lat": 37.379629,
        "lng": -6.003709499999999
    },
    {
        "id": "267de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1102037",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "531.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "409.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "568.70",
        "surfaceTotal": "940.40",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle El Rabal 26 ",
        "postalCode": "02400",
        "lat": 38.5126317,
        "lng": -1.7016408
    },
    {
        "id": "227de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1130100",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "390.16",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "390.16",
        "surfaceTotal": "390.16",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Mayor 38 ",
        "postalCode": "30100",
        "lat": 38.0088655,
        "lng": -1.1518313
    },
    {
        "id": "2c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108114",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "15.87",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "15.87",
        "surfaceTotal": "15.87",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza Villa 45 ",
        "postalCode": "08760",
        "lat": 41.4746792,
        "lng": 1.9313529
    },
    {
        "id": "4c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1118017",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "99.93",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.97",
        "surfaceTotal": "255.93",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Del Altillo 3 ",
        "postalCode": "18690",
        "lat": 36.7318927,
        "lng": -3.6892642
    },
    {
        "id": "607de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza Española 8 ",
        "postalCode": "08904",
        "lat": 41.3705933,
        "lng": 2.1218538
    },
    {
        "id": "2e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1131254",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "53.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "213.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "229.06",
        "surfaceTotal": "266.31",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida De España 2 ",
        "lat": 40.3100679,
        "lng": -3.7237161
    },
    {
        "id": "627de90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "lat": 41.3681349,
        "lng": 2.1297714
    },
    {
        "id": "a27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "VENTA",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.33",
        "surfaceTotal": "224.33",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Sants 76 ",
        "postalCode": "08014",
        "lat": 41.375478,
        "lng": 2.1370769
    },
    {
        "id": "a67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "74.33",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.63",
        "surfaceTotal": "148.66",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Constitución 37 ",
        "postalCode": "08014",
        "lat": 41.3697092,
        "lng": 2.1366807
    },
    {
        "id": "b67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146184",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "289.13",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "39.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "308.63",
        "surfaceTotal": "328.13",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Concepción 6 ",
        "postalCode": "46870",
        "lat": 38.8255071,
        "lng": -0.603502
    },
    {
        "id": "e87de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1147086",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Pablo Iglesias 1 ",
        "postalCode": "47800",
        "lat": 41.8832126,
        "lng": -5.0442973
    },
    {
        "id": "c07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "CAMBIO DE USO",
        "city": "1108077",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "100.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "240.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Carretera De Cornella 121 ",
        "postalCode": "08950",
        "lat": 41.37068,
        "lng": 2.08251
    },
    {
        "id": "de7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "69.73",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "123.14",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.14",
        "surfaceTotal": "267.52",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Reina Victoria 70 ",
        "postalCode": "28003",
        "lat": 40.4463442,
        "lng": -3.7144371
    },
    {
        "id": "9a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "78.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "183.35",
        "surfaceTotal": "222.70",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Valderribas ",
        "postalCode": "28007",
        "lat": 40.4039167,
        "lng": -3.6744662
    },
    {
        "id": "e27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "33.08",
        "surfaceMezzanine": "0.00",
        "surfacepb": "142.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.02",
        "surfaceTotal": "175.18",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Alcalá 205 ",
        "postalCode": "28028",
        "lat": 40.42920230000001,
        "lng": -3.6670872
    },
    {
        "id": "987de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "75.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "97.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "58.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.50",
        "surfaceTotal": "230.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Jose Abascal ",
        "postalCode": "28003",
        "lat": 40.4383502,
        "lng": -3.6974384
    },
    {
        "id": "f27de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1134157",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Conde De Garay 3 ",
        "postalCode": "34100",
        "lat": 42.5213757,
        "lng": -4.736257999999999
    },
    {
        "id": "8a7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "303.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "303.76",
        "surfaceTotal": "303.76",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "e07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "115.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.50",
        "surfaceTotal": "315.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle O'Donell 43 ",
        "postalCode": "28009",
        "lat": 40.4216539,
        "lng": -3.6747361
    },
    {
        "id": "c27de90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "114.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "45.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.17",
        "surfaceTotal": "281.71",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Rosendo Arus 39 ",
        "postalCode": "08901",
        "lat": 41.35807399999999,
        "lng": 2.1001846
    },
    {
        "id": "867ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "VENTA",
        "city": "1108124",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.95",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.95",
        "surfaceTotal": "164.95",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Francesc Layret 59 ",
        "postalCode": "08100",
        "lat": 41.5463345,
        "lng": 2.2038023
    },
    {
        "id": "347de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1145163",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "294.56",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "350.50",
        "surfaceTotal": "497.78",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Mayor 11 ",
        "postalCode": "45100",
        "lat": 39.6764458,
        "lng": -3.9754467
    },
    {
        "id": "7c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1102033",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.38",
        "surfaceTotal": "155.38",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Lorca ",
        "postalCode": "30320",
        "lat": 37.7237765,
        "lng": -1.1718824
    },
    {
        "id": "6c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146205",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "396.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "396.66",
        "surfaceTotal": "396.66",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " San Juan 62 ",
        "postalCode": "46020",
        "lat": 39.6167085,
        "lng": -0.3024512
    },
    {
        "id": "407ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "ALQUILER",
        "city": "1115036",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "87.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "87.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.10",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle San Salvador 1 ",
        "postalCode": "15402",
        "lat": 43.4909109,
        "lng": -8.217689
    },
    {
        "id": "7e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "strategy": "CAMBIO DE USO",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.20",
        "surfaceTotal": "190.20",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Euskadi 28 ",
        "postalCode": "48902",
        "lat": 43.2915561,
        "lng": -2.9917371
    },
    {
        "id": "887de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Almacén",
        "surfacebr": "3209.98",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "962.99",
        "surfaceTotal": "3209.98",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Francisco Ruiz 9 ",
        "postalCode": "28005",
        "lat": 40.3821502,
        "lng": -3.7034895
    },
    {
        "id": "d67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120064",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.94",
        "surfaceTotal": "220.94",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Zumalacarregui 6 ",
        "postalCode": "20110",
        "lat": 43.32547030000001,
        "lng": -1.9301396
    },
    {
        "id": "407de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1142020",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.21",
        "surfaceTotal": "150.21",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Caballeros 3 ",
        "postalCode": "42200",
        "lat": 41.5128796,
        "lng": -2.5594214
    },
    {
        "id": "b27ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124202",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "48.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "242.09",
        "surfaceTotal": "275.69",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Juan Alvarado 9 ",
        "postalCode": "24100",
        "lat": 42.9390778,
        "lng": -6.3162588
    },
    {
        "id": "647de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103014",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.58",
        "surfaceTotal": "143.58",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Condomina 19 ",
        "postalCode": "03002",
        "lat": 38.3636728,
        "lng": -0.4441291
    },
    {
        "id": "c07ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1105114",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": " Tostado 1 ",
        "postalCode": "05220",
        "lat": 41.0893068,
        "lng": -4.9980684
    },
    {
        "id": "6e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "140.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "135.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "19.43",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "140.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.02",
        "surfaceTotal": "294.73",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Eugenio Gross 10 ",
        "postalCode": "29016",
        "lat": 36.7223182,
        "lng": -4.435663
    },
    {
        "id": "a67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141065",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "353.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "353.05",
        "surfaceTotal": "353.05",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Calle Nuevo 27 ",
        "postalCode": "41530",
        "lat": 37.1205814,
        "lng": -5.4513437
    },
    {
        "id": "4e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133073",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.00",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De Gonzalez Mayo 30 ",
        "postalCode": "33870",
        "lat": 43.3369192,
        "lng": -6.415847299999999
    },
    {
        "id": "167de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103047",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "78.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.46",
        "surfaceTotal": "248.20",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Avenida Juan Carlos I 26 ",
        "postalCode": "03710",
        "lat": 38.6454651,
        "lng": 0.0728883
    },
    {
        "id": "b67ce90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1138026",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Plaza De La Constitucion 10 ",
        "postalCode": "38300",
        "lat": 28.3900576,
        "lng": -16.5235211
    },
    {
        "id": "847de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108096",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "100.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.88",
        "surfaceTotal": "243.88",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Gerona 25 ",
        "postalCode": "08400",
        "lat": 41.61065370000001,
        "lng": 2.2906858
    },
    {
        "id": "1c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "494.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "481.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "629.85",
        "surfaceTotal": "976.00",
        "timeAvailableFrom": "9/13/22 13:21",
        "address": "Gran Vía De Gracia 75 ",
        "postalCode": "08012",
        "lat": 41.3885334,
        "lng": 2.1691051
    },
    {
        "id": "3e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "13.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.90",
        "surfaceTotal": "199.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Obispo Romo 14 ",
        "postalCode": "35011",
        "lat": 28.1146851,
        "lng": -15.4351335
    },
    {
        "id": "747de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " La Reina 166 ",
        "postalCode": "46002",
        "lat": 39.4700619,
        "lng": -0.3283401
    },
    {
        "id": "107ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Eustasio Amilibia 12 ",
        "postalCode": "20011",
        "lat": 43.3050669,
        "lng": -1.9783452
    },
    {
        "id": "087ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "262.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "262.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "393.00",
        "surfaceTotal": "524.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Lealtad 21 ",
        "postalCode": "39002",
        "lat": 43.4614062,
        "lng": -3.8084357
    },
    {
        "id": "f47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108200",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Cerdeña 76-84 ",
        "postalCode": "08830",
        "lat": 41.3458415,
        "lng": 2.035041
    },
    {
        "id": "3481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1121041",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.77",
        "surfaceTotal": "99.77",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Huelva S/N ",
        "postalCode": "21004",
        "lat": 37.2619585,
        "lng": -6.9427327
    },
    {
        "id": "487de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "175.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "278.64",
        "surfaceTotal": "366.14",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Balmes 386 ",
        "postalCode": "08002",
        "lat": 41.4050496,
        "lng": 2.139982
    },
    {
        "id": "227ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103066",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Chapi 2 ",
        "postalCode": "03600",
        "lat": 38.476176,
        "lng": -0.7965637
    },
    {
        "id": "187ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1136055",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "157.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "165.65",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "204.10",
        "surfaceTotal": "314.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Martinez Padin 2 ",
        "postalCode": "36700",
        "lat": 42.0490974,
        "lng": -8.6468457
    },
    {
        "id": "8a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108056",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.75",
        "surfaceTotal": "134.75",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " General De Palafox 5 ",
        "postalCode": "08860",
        "lat": 41.286191,
        "lng": 1.981673
    },
    {
        "id": "327ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Angli 39 ",
        "postalCode": "08017",
        "lat": 41.401347,
        "lng": 2.1249814
    },
    {
        "id": "c47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108102",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Edificio Plaza De La Cruz 6 ",
        "postalCode": "08700",
        "lat": 41.5847817,
        "lng": 1.6226538
    },
    {
        "id": "8e7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114054",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "230.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "230.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Real 14Planta. 2 ",
        "postalCode": "14400",
        "lat": 38.3770629,
        "lng": -4.8494709
    },
    {
        "id": "e67de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "103.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.95",
        "surfaceTotal": "259.40",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Real 76 ",
        "postalCode": "28700",
        "lat": 40.5481434,
        "lng": -3.6245168
    },
    {
        "id": "e47de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.86",
        "surfaceTotal": "227.86",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle de San Germán, 43 ",
        "postalCode": "28020",
        "lat": 40.4569756,
        "lng": -3.6995717
    },
    {
        "id": "8c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115054",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.00",
        "surfaceTotal": "167.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Carretera Castilla 107 ",
        "postalCode": "15407",
        "lat": 43.4979907,
        "lng": -8.1992183
    },
    {
        "id": "fa7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1141086",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Felix Rguez. De La Fuente 1-3 ",
        "postalCode": "41920",
        "lat": 37.3592432,
        "lng": -6.0343054
    },
    {
        "id": "fc7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1134023",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "65.47",
        "surfaceTotal": "65.47",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Castilla Y Leon, 2 ",
        "postalCode": "34200",
        "lat": 41.9182147,
        "lng": -4.498277
    },
    {
        "id": "8c7de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1143055",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "85.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "463.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.04",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "553.27",
        "surfaceTotal": "677.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Miguel Barcelo 2 ",
        "postalCode": "43730",
        "lat": 41.1448302,
        "lng": 0.8205283999999999
    },
    {
        "id": "8e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114030",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.60",
        "surfaceTotal": "173.60",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Carlos Iii ",
        "postalCode": "14120",
        "lat": 37.7055557,
        "lng": -5.1039618
    },
    {
        "id": "9c7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.90",
        "surfaceTotal": "120.90",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Moquetas 1 ",
        "postalCode": "28029",
        "lat": 40.4661605,
        "lng": -3.7009246
    },
    {
        "id": "947ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128006",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De La Industria 6 ",
        "postalCode": "28108",
        "lat": 40.53554200000001,
        "lng": -3.64298
    },
    {
        "id": "9a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "144.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "144.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.20",
        "surfaceTotal": "432.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Marques De Corbera 15 ",
        "postalCode": "28017",
        "lat": 40.4237422,
        "lng": -3.6549893
    },
    {
        "id": "967ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "53.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "77.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "53.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "92.90",
        "surfaceTotal": "130.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Maldonado 31 ",
        "postalCode": "28006",
        "lat": 40.4339842,
        "lng": -3.681439
    },
    {
        "id": "7a7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Nave industrial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "209.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "105.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.31",
        "surfaceTotal": "314.86",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Fuentemar 43 ",
        "postalCode": "28820",
        "lat": 40.4352999,
        "lng": -3.5429247
    },
    {
        "id": "927ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141050",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "105.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "105.00",
        "surfaceTotal": "105.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza De España 2 ",
        "postalCode": "41567",
        "lat": 37.3652629,
        "lng": -4.8497614
    },
    {
        "id": "607ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1111015",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "114.04",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "114.04",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "347.02",
        "surfaceTotal": "404.04",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza España 5 ",
        "postalCode": "11130",
        "lat": 36.4198135,
        "lng": -6.1452218
    },
    {
        "id": "987ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "237.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.36",
        "surfaceTotal": "237.36",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Mar De Aral 9 ",
        "postalCode": "28033",
        "lat": 40.4745693,
        "lng": -3.6436596
    },
    {
        "id": "907ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo De Las Delicias 51 ",
        "postalCode": "28045",
        "lat": 40.4025509,
        "lng": -3.693565
    },
    {
        "id": "a07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "471.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "471.00",
        "surfaceTotal": "471.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Ntra. Sra. Fátima 4 ",
        "postalCode": "28047",
        "lat": 40.3867764,
        "lng": -3.7438462
    },
    {
        "id": "9e7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "121.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.48",
        "surfaceTotal": "273.82",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Mota Del Cuervo 21 ",
        "postalCode": "28043",
        "lat": 40.4653883,
        "lng": -3.630666199999999
    },
    {
        "id": "a27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Nuestra Señora De Valverde, 25 ",
        "postalCode": "28034",
        "lat": 40.4931125,
        "lng": -3.6870949
    },
    {
        "id": "727ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Mendizabal 10 ",
        "postalCode": "35001",
        "lat": 28.1021578,
        "lng": -15.4136948
    },
    {
        "id": "a87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": false,
        "surfacebr": "235.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "263.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "333.50",
        "surfaceTotal": "498.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Puenteareas 17 ",
        "postalCode": "28002",
        "lat": 40.4442149,
        "lng": -3.6692264
    },
    {
        "id": "a47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "278.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "50.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "303.00",
        "surfaceTotal": "328.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Nuñez De Balboa 61 ",
        "postalCode": "28001",
        "lat": 40.428341,
        "lng": -3.682633699999999
    },
    {
        "id": "a67ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "104.12",
        "surfaceMezzanine": "0.00",
        "surfacepb": "204.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "104.12",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.36",
        "surfaceTotal": "308.24",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Presidente Carmona 10 ",
        "postalCode": "28020",
        "lat": 40.4544248,
        "lng": -3.6968133
    },
    {
        "id": "aa7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "141.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.45",
        "surfaceTotal": "141.45",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Real De Pinto 13 ",
        "postalCode": "28021",
        "lat": 40.34802699999999,
        "lng": -3.7061509
    },
    {
        "id": "ac7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "218.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.28",
        "surfaceTotal": "218.28",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Sanchez Barcaiztegui 4 ",
        "postalCode": "28007",
        "lat": 40.4025197,
        "lng": -3.6756938
    },
    {
        "id": "ae7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.75",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.75",
        "surfaceTotal": "203.75",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Sierra Contraviesa 28 ",
        "postalCode": "28053",
        "lat": 40.3834032,
        "lng": -3.6714547
    },
    {
        "id": "b27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "208.00",
        "surfaceTotal": "208.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Valdecanillas 35 ",
        "postalCode": "28037",
        "lat": 40.4318702,
        "lng": -3.6273327
    },
    {
        "id": "ba7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108123",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "163.86",
        "surfaceTotal": "163.86",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Del Terraple 25 ",
        "postalCode": "08750",
        "lat": 41.41068,
        "lng": 2.01623
    },
    {
        "id": "b07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "279.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "279.00",
        "surfaceTotal": "279.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Sierra Vieja 72 ",
        "postalCode": "28031",
        "lat": 40.3789958,
        "lng": -3.6227853
    },
    {
        "id": "c07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123060",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "419.83",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "153.17",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "380.51",
        "surfaceTotal": "750.98",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Carrera 17 ",
        "postalCode": "23600",
        "lat": 37.7213433,
        "lng": -3.969569
    },
    {
        "id": "b67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136026",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.00",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Jaime Janer 24 ",
        "postalCode": "36900",
        "lat": 42.39052,
        "lng": -8.702259999999999
    },
    {
        "id": "b87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1147086",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "263.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.67",
        "surfaceTotal": "263.67",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Pablo Iglesias 2 ",
        "postalCode": "47800",
        "lat": 41.8831643,
        "lng": -5.0440737
    },
    {
        "id": "b47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "111.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "63.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.30",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Doctor Esquerdo 6 ",
        "postalCode": "28028",
        "lat": 40.4266101,
        "lng": -3.668793899999999
    },
    {
        "id": "bc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1109211",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza De España 6 ",
        "postalCode": "09100",
        "lat": 42.4026689,
        "lng": -4.2448712
    },
    {
        "id": "c27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1109219",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "277.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "247.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "330.65",
        "surfaceTotal": "524.90",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Gregorio Solabarrieta 1 ",
        "postalCode": "09200",
        "lat": 42.6848641,
        "lng": -2.9490826
    },
    {
        "id": "d47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1146159",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "70.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "60.10",
        "surfacesr": "60.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.05",
        "surfaceTotal": "130.10",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Santos Justo Y Pastor 3 ",
        "postalCode": "46940",
        "lat": 39.4934052,
        "lng": -0.4663584
    },
    {
        "id": "cc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104064",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.00",
        "surfaceTotal": "87.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Glorieta 5 ",
        "postalCode": "04638",
        "lat": 37.1406407,
        "lng": -1.8515094
    },
    {
        "id": "de7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "40.00",
        "surfacepb": "267.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "40.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "287.00",
        "surfaceTotal": "307.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza Alta 12 ",
        "postalCode": "11201",
        "lat": 36.1307875,
        "lng": -5.447254
    },
    {
        "id": "d07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129069",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "39.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "77.41",
        "surfaceTotal": "104.95",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Torres Murciano 10 ",
        "postalCode": "29600",
        "lat": 36.5124205,
        "lng": -4.875605699999999
    },
    {
        "id": "c67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.60",
        "surfaceTotal": "171.60",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Ronda De Levante 49 ",
        "postalCode": "30008",
        "lat": 37.99113090000001,
        "lng": -1.1213992
    },
    {
        "id": "ca7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108113",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "102.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "360.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "118.10",
        "surfacesr": "118.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "450.21",
        "surfaceTotal": "581.22",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Pere lii 6 ",
        "postalCode": "08240",
        "lat": 41.7258175,
        "lng": 1.8238172
    },
    {
        "id": "d27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108125",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "56.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "56.00",
        "surfaceTotal": "56.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Maria Fortuny 1 ",
        "postalCode": "08110",
        "lat": 41.4969362,
        "lng": 2.1813595
    },
    {
        "id": "c47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.00",
        "surfaceTotal": "280.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Floridablanca 3 ",
        "postalCode": "30002",
        "lat": 37.9786313,
        "lng": -1.1307672
    },
    {
        "id": "be7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1127031",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "55.17",
        "surfacepb": "220.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "55.17",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "248.39",
        "surfaceTotal": "275.97",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De Galicia 34 ",
        "postalCode": "27400",
        "lat": 42.5206954,
        "lng": -7.515005599999999
    },
    {
        "id": "c87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108113",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "205.33",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "114.66",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "262.66",
        "surfaceTotal": "319.99",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza Bages 15 ",
        "postalCode": "08242",
        "lat": 41.7345455,
        "lng": 1.823816
    },
    {
        "id": "e27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1133041",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "140.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.67",
        "surfaceTotal": "283.67",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Regueral 2 ",
        "postalCode": "33710",
        "lat": 43.5387957,
        "lng": -6.724752
    },
    {
        "id": "e67ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1104066",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.35",
        "surfaceTotal": "137.35",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle El Parque 4 ",
        "postalCode": "04100",
        "lat": 36.9659458,
        "lng": -2.2074125
    },
    {
        "id": "d87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108121",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.24",
        "surfaceTotal": "220.24",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Paseo Ramon Berenguer 133 ",
        "postalCode": "08303",
        "lat": 41.5385786,
        "lng": 2.4264686
    },
    {
        "id": "dc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1121050",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "304.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "304.00",
        "surfaceTotal": "304.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Juan Ramon Jimenez 6 ",
        "postalCode": "21800",
        "lat": 37.2761106,
        "lng": -6.837214599999999
    },
    {
        "id": "e87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.88",
        "surfaceTotal": "112.88",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida España 4 ",
        "postalCode": "11205",
        "lat": 36.1475235,
        "lng": -5.451941
    },
    {
        "id": "ce7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130027",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "151.89",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.20",
        "surfaceTotal": "321.52",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Plaza De La Constitucion 1 ",
        "postalCode": "30500",
        "lat": 38.0507565,
        "lng": -1.2105534
    },
    {
        "id": "ee7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.56",
        "surfaceTotal": "179.56",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Camino De Los Sastres 3-5 ",
        "postalCode": "14004",
        "lat": 37.8813255,
        "lng": -4.7896867
    },
    {
        "id": "e07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128082",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "72.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "72.00",
        "surfaceTotal": "72.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Real 5 ",
        "postalCode": "28410",
        "lat": 40.725942,
        "lng": -3.8667664
    },
    {
        "id": "d67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1143086",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "16.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "91.38",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.87",
        "surfaceTotal": "203.76",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Riber 38 ",
        "postalCode": "43400",
        "lat": 41.3764917,
        "lng": 1.163502
    },
    {
        "id": "f47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.93",
        "surfaceTotal": "160.93",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Cuesta De La Polvora 2 ",
        "postalCode": "14010",
        "lat": 37.8804062,
        "lng": -4.7668327
    },
    {
        "id": "ec7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "141.05",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "141.05",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.94",
        "surfaceTotal": "265.67",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Glorieta Amadora s/n ",
        "postalCode": "14011",
        "lat": 37.8933066,
        "lng": -4.7989804
    },
    {
        "id": "da7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114042",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "206.86",
        "surfaceMezzanine": "0.00",
        "surfacepb": "283.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "345.56",
        "surfaceTotal": "490.36",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle La Corredera 40 ",
        "postalCode": "14550",
        "lat": 37.5885372,
        "lng": -4.6387797
    },
    {
        "id": "087fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1129631",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "91.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "91.00",
        "surfaceTotal": "91.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Federico Garcia Lorca 37 ",
        "postalCode": "29630",
        "lat": 36.5992694,
        "lng": -4.5317973
    },
    {
        "id": "fc7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "72.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "127.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.55",
        "surfaceTotal": "200.23",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Cervantes 17 ",
        "postalCode": "33004",
        "lat": 43.3629612,
        "lng": -5.8563627
    },
    {
        "id": "047fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1101043",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.00",
        "surfaceTotal": "94.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De Navarra 31 ",
        "postalCode": "01320",
        "lat": 42.504711,
        "lng": -2.4355867
    },
    {
        "id": "fa7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115077",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Alfonso Molina 63 ",
        "postalCode": "15186",
        "lat": 43.0338493,
        "lng": -8.8095116
    },
    {
        "id": "027fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "80.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "80.00",
        "surfaceTotal": "80.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Aureliano San Roman 41 ",
        "postalCode": "33011",
        "lat": 43.3707845,
        "lng": -5.838556899999999
    },
    {
        "id": "0a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108156",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "308.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "308.00",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Cataluña 200 ",
        "postalCode": "08184",
        "lat": 41.5855883,
        "lng": 2.1803999
    },
    {
        "id": "187fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "VENTA",
        "city": "1124115",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "129.00",
        "surfaceTotal": "129.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Galicia 82 ",
        "postalCode": "24400",
        "lat": 42.5606612,
        "lng": -6.625151199999999
    },
    {
        "id": "1a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128106",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.00",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Estrella Antares 7 ",
        "postalCode": "28983",
        "lat": 40.2288421,
        "lng": -3.755848799999999
    },
    {
        "id": "f27ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.00",
        "surfaceTotal": "187.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Cruz Juarez 10 ",
        "postalCode": "14006",
        "lat": 37.8936537,
        "lng": -4.7805314
    },
    {
        "id": "167fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124115",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "167.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "167.69",
        "surfaceTotal": "167.69",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De La Martina 30 ",
        "postalCode": "24400",
        "lat": 42.5463663,
        "lng": -6.6167834
    },
    {
        "id": "e47ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108040",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "257.46",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.46",
        "surfaceTotal": "257.46",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Via Canetum 6 ",
        "postalCode": "08360",
        "lat": 41.5918998,
        "lng": 2.5726277
    },
    {
        "id": "267fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1135660",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "379.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "379.00",
        "surfaceTotal": "379.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Hibisco 1 ",
        "postalCode": "35660",
        "lat": 28.7292425,
        "lng": -13.8643128
    },
    {
        "id": "0e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "119.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "263.35",
        "surfaceTotal": "346.65",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida De Bayona 37 ",
        "postalCode": "31011",
        "lat": 42.8131303,
        "lng": -1.6607284
    },
    {
        "id": "107fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Felipe Gorriti 31 ",
        "postalCode": "31004",
        "lat": 42.8118339,
        "lng": -1.6361076
    },
    {
        "id": "f07ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.00",
        "surfaceTotal": "149.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Conde Vallellano 17 ",
        "postalCode": "14004",
        "lat": 37.87645759999999,
        "lng": -4.7852198
    },
    {
        "id": "147fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1101002",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.00",
        "surfaceTotal": "175.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Larrinaga 1 ",
        "postalCode": "01470",
        "lat": 43.0522466,
        "lng": -3.0015693
    },
    {
        "id": "307fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120067",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Navarra 26 ",
        "postalCode": "20100",
        "lat": 43.3150486,
        "lng": -1.9022344
    },
    {
        "id": "f67ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103095",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.00",
        "surfaceTotal": "185.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida D'Alacant 21 ",
        "postalCode": "03760",
        "lat": 38.8251161,
        "lng": 0.0194117
    },
    {
        "id": "347fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128123",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Cincel 4 ",
        "postalCode": "28522",
        "lat": 40.3494777,
        "lng": -3.5425987
    },
    {
        "id": "247fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128115",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "105.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "85.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.50",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Concepcion 7 ",
        "postalCode": "28223",
        "lat": 40.4356176,
        "lng": -3.8138212
    },
    {
        "id": "067fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1129631",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "428.40",
        "surfaceMezzanine": "0.00",
        "surfacepb": "407.59",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "428.40",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "536.11",
        "surfaceTotal": "835.99",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Antonio Machado 29 ",
        "postalCode": "29630",
        "lat": 36.5966157,
        "lng": -4.5186568
    },
    {
        "id": "1c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135017",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "80.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.35",
        "surfaceTotal": "237.35",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Juan Tadeo Cabrera 8 ",
        "postalCode": "35600",
        "lat": 28.4975105,
        "lng": -13.8612883
    },
    {
        "id": "2c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1104079",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "214.73",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "19.43",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.45",
        "surfaceTotal": "234.16",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Aduana 16 ",
        "postalCode": "04740",
        "lat": 36.7668199,
        "lng": -2.6134578
    },
    {
        "id": "2e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1117197",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "197.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "197.31",
        "surfaceTotal": "197.31",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Caja De Ahorros 13 ",
        "postalCode": "46900",
        "lat": 39.430841,
        "lng": -0.4725859
    },
    {
        "id": "1e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1110148",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "486.07",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "529.09",
        "surfaceTotal": "772.12",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Talavera 26 ",
        "postalCode": "10600",
        "lat": 40.0291598,
        "lng": -6.0894211
    },
    {
        "id": "fe7ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.25",
        "surfaceTotal": "154.25",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Fray Ceferino 40 ",
        "postalCode": "33011",
        "lat": 43.3685299,
        "lng": -5.8488605
    },
    {
        "id": "3e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1139075",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.70",
        "surfaceTotal": "121.70",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle General Davila 256 ",
        "postalCode": "39006",
        "lat": 43.4683534,
        "lng": -3.8094016
    },
    {
        "id": "227fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1146190",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.88",
        "surfaceTotal": "150.88",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Font Del Gerro 65 ",
        "postalCode": "46980",
        "lat": 39.5086015,
        "lng": -0.4549464
    },
    {
        "id": "387fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108205",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "6.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "6.00",
        "surfaceWeighted": "292.38",
        "surfaceTotal": "296.58",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Catalunya 20 ",
        "postalCode": "08172",
        "lat": 41.4727602,
        "lng": 2.0802962
    },
    {
        "id": "207fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111027",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.40",
        "surfaceTotal": "161.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Oceano S/N ",
        "postalCode": "11500",
        "lat": 36.6110022,
        "lng": -6.2085841
    },
    {
        "id": "f87ee90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1115411",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "177.00",
        "surfaceTotal": "177.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Rua Agro Do Medio 6 ",
        "postalCode": "15895",
        "lat": 42.8442,
        "lng": -8.5778106
    },
    {
        "id": "287fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108184",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.77",
        "surfaceTotal": "173.77",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Carretera De Sabadell 18 ",
        "postalCode": "08191",
        "lat": 41.4973844,
        "lng": 2.0321877
    },
    {
        "id": "0c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "456.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "456.00",
        "surfaceTotal": "456.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Avenida Gabriel Alomar I Villalonga, 6 ",
        "postalCode": "07002",
        "lat": 39.5708556,
        "lng": 2.6566375
    },
    {
        "id": "367fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "460.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "460.00",
        "surfaceTotal": "460.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza De Vigo 1 ",
        "postalCode": "15706",
        "lat": 42.8737477,
        "lng": -8.551578899999999
    },
    {
        "id": "2a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108180",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.32",
        "surfaceTotal": "121.32",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Onze De Septiembre 2 ",
        "postalCode": "08291",
        "lat": 41.4970233,
        "lng": 2.1578214
    },
    {
        "id": "327fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "213.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "213.00",
        "surfaceTotal": "213.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza De La Llibertat 1 ",
        "postalCode": "43201",
        "lat": 41.1577803,
        "lng": 1.1057711
    },
    {
        "id": "127fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1147114",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.00",
        "surfaceTotal": "187.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": "Calle Capitan Rojas 34 ",
        "postalCode": "47300",
        "lat": 41.5975749,
        "lng": -4.1193523
    },
    {
        "id": "627fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1129740",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo De Larios 1 ",
        "postalCode": "29740",
        "lat": 36.741924,
        "lng": -4.0932879
    },
    {
        "id": "407fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128130",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.53",
        "surfaceTotal": "137.53",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Motrico 11 ",
        "postalCode": "28830",
        "lat": 40.4191722,
        "lng": -3.52775
    },
    {
        "id": "5e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "94.75",
        "surfacepb": "196.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "94.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "244.07",
        "surfaceTotal": "291.44",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Recaredo 5 ",
        "postalCode": "41003",
        "lat": 37.3902388,
        "lng": -5.9844086
    },
    {
        "id": "467fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1137274",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "43.63",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.63",
        "surfaceTotal": "43.63",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Lasalle 43 ",
        "postalCode": "37008",
        "lat": 40.9548624,
        "lng": -5.6796734
    },
    {
        "id": "667fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129901",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.40",
        "surfaceTotal": "100.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Rafael Quintana 16 ",
        "postalCode": "29620",
        "lat": 36.6224427,
        "lng": -4.5052072
    },
    {
        "id": "5a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.00",
        "surfaceTotal": "264.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Hytasa 61 ",
        "postalCode": "41006",
        "lat": 37.3707229,
        "lng": -5.9599993
    },
    {
        "id": "4c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128133",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Corredera Alta 2 ",
        "postalCode": "28680",
        "lat": 40.3612211,
        "lng": -4.4009903
    },
    {
        "id": "767fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120903",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Pelotari 7 ",
        "postalCode": "20115",
        "lat": 43.2826115,
        "lng": -1.948238
    },
    {
        "id": "687fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146015",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.94",
        "surfaceTotal": "118.94",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Maestro Serrano 1 ",
        "postalCode": "46290",
        "lat": 39.3715521,
        "lng": -0.4410694
    },
    {
        "id": "4e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129015",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "65.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "479.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "389.90",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "693.68",
        "surfaceTotal": "934.13",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Infante Don Fernando 21 ",
        "postalCode": "29200",
        "lat": 37.0177099,
        "lng": -4.561056
    },
    {
        "id": "5c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "VENTA",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Nave industrial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.00",
        "surfaceTotal": "132.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Gramil 15 ",
        "postalCode": "41008",
        "lat": 37.40937,
        "lng": -5.96047
    },
    {
        "id": "427fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1117160",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Rutlla 20 ",
        "postalCode": "17220",
        "lat": 41.7823232,
        "lng": 3.0298517
    },
    {
        "id": "887fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Gran Via 55 ",
        "postalCode": "36209",
        "lat": 42.2302971,
        "lng": -8.718560799999999
    },
    {
        "id": "507fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130036",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "184.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "184.00",
        "surfaceTotal": "184.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Artero Guirao 120 ",
        "postalCode": "30740",
        "lat": 37.83500799999999,
        "lng": -0.7920279000000001
    },
    {
        "id": "747fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "129.30",
        "surfaceTotal": "129.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Roma 3 ",
        "postalCode": "28850",
        "lat": 40.458102,
        "lng": -3.4710192
    },
    {
        "id": "6a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133073",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.00",
        "surfaceTotal": "194.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Travesía General Riego s/n ",
        "postalCode": "33870",
        "lat": 43.3350916,
        "lng": -6.4168184
    },
    {
        "id": "567fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108263",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.40",
        "surfaceTotal": "99.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Jacint Verdaguer 278 ",
        "postalCode": "08620",
        "lat": 41.4011368,
        "lng": 2.0054248
    },
    {
        "id": "3a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1138038",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "36.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "185.83",
        "surfaceTotal": "211.51",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Los Majuelos 69 ",
        "postalCode": "38107",
        "lat": 28.4364668,
        "lng": -16.3192802
    },
    {
        "id": "727fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128903",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.30",
        "surfaceTotal": "112.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Del Toro S/N ",
        "postalCode": "28760",
        "lat": 40.6061771,
        "lng": -3.7167757
    },
    {
        "id": "547fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "CAMBIO DE USO",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "76.40",
        "surfaceTotal": "76.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Valdelasfuentes 9 ",
        "postalCode": "28700",
        "lat": 40.5517467,
        "lng": -3.6335103
    },
    {
        "id": "487fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1137274",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "278.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "278.50",
        "surfaceTotal": "278.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Raimundo De Borgoña 1-15 ",
        "postalCode": "37005",
        "lat": 40.9769777,
        "lng": -5.663625499999999
    },
    {
        "id": "527fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.05",
        "surfaceTotal": "104.05",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Los Quiñones 1 ",
        "postalCode": "28702",
        "lat": 40.5620043,
        "lng": -3.6192624
    },
    {
        "id": "827fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1105019",
        "province": "05",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "53.96",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "239.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.19",
        "surfaceTotal": "412.46",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Comandante Albarran 6 ",
        "postalCode": "05001",
        "lat": 40.6545384,
        "lng": -4.6946385
    },
    {
        "id": "447fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1118173",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.37",
        "surfaceTotal": "155.37",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Antonio Machado 4 ",
        "postalCode": "18680",
        "lat": 36.7455671,
        "lng": -3.5852099
    },
    {
        "id": "707fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108279",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "188.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.30",
        "surfaceTotal": "188.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Independencia 44 ",
        "postalCode": "08225",
        "lat": 41.5727526,
        "lng": 2.0144269
    },
    {
        "id": "807fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1123097",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "168.78",
        "surfaceMezzanine": "0.00",
        "surfacepb": "168.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.41",
        "surfaceTotal": "337.56",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Carrera 3 ",
        "postalCode": "23330",
        "lat": 38.16967169999999,
        "lng": -3.0092646
    },
    {
        "id": "847fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108301",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.30",
        "surfaceTotal": "231.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle De Modolell 52 ",
        "postalCode": "08840",
        "lat": 41.318587,
        "lng": 2.0193036
    },
    {
        "id": "a27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "141.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.22",
        "surfaceTotal": "141.22",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Huelgas 10 ",
        "postalCode": "47005",
        "lat": 41.6521014,
        "lng": -4.7165576
    },
    {
        "id": "867fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1132085",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.42",
        "surfaceTotal": "280.42",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Luis Espada 51 ",
        "postalCode": "32600",
        "lat": 41.940337,
        "lng": -7.4369947
    },
    {
        "id": "6c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.40",
        "surfaceTotal": "169.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Diego Ramirez Pastor 22 ",
        "postalCode": "03181",
        "lat": 37.97939,
        "lng": -0.6892699999999999
    },
    {
        "id": "7c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111038",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza De Colon 5 ",
        "postalCode": "11600",
        "lat": 36.6767992,
        "lng": -5.443650799999999
    },
    {
        "id": "607fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108006",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.00",
        "surfaceTotal": "181.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Riera Del Bisbe Pol 5 ",
        "postalCode": "08350",
        "lat": 41.5792247,
        "lng": 2.5510798
    },
    {
        "id": "7e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1139008",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.43",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.43",
        "surfaceTotal": "255.43",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle 18 De Julio 30 ",
        "postalCode": "39610",
        "lat": 43.40085089999999,
        "lng": -3.8241287
    },
    {
        "id": "647fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1145165",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "207.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "207.71",
        "surfaceTotal": "207.71",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Capitan Cortes 9 ",
        "postalCode": "45600",
        "lat": 39.96583,
        "lng": -4.8236417
    },
    {
        "id": "587fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "109.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.82",
        "surfaceTotal": "217.67",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Dr.Jimenez Diaz 6 ",
        "postalCode": "41008",
        "lat": 37.4038175,
        "lng": -5.980731899999999
    },
    {
        "id": "6e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1130037",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.50",
        "surfaceTotal": "158.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Estación 32 ",
        "postalCode": "30700",
        "lat": 37.7443595,
        "lng": -0.9567668
    },
    {
        "id": "787fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1137008",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "115.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.50",
        "surfaceTotal": "260.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Sanchez Llevot 10 ",
        "postalCode": "37800",
        "lat": 40.8269469,
        "lng": -5.5135708
    },
    {
        "id": "8c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.93",
        "surfaceTotal": "158.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Canciller Ayala 9 ",
        "postalCode": "01004",
        "lat": 42.8433321,
        "lng": -2.6654304
    },
    {
        "id": "8a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1104102",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.00",
        "surfaceTotal": "119.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Boulevar Ciudad De Vicar, 619 ",
        "postalCode": "04738",
        "lat": 36.8050566,
        "lng": -2.6193275
    },
    {
        "id": "907fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.00",
        "surfaceTotal": "225.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Francia 25 ",
        "postalCode": "01004",
        "lat": 42.8486407,
        "lng": -2.6685404
    },
    {
        "id": "947fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.64",
        "surfaceTotal": "196.64",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Burjasot 91 ",
        "postalCode": "46009",
        "lat": 39.4880966,
        "lng": -0.3892198
    },
    {
        "id": "7a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1139087",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.02",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.02",
        "surfaceTotal": "94.02",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Palencia 9 ",
        "postalCode": "39300",
        "lat": 43.3453095,
        "lng": -4.056539799999999
    },
    {
        "id": "9a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.89",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.89",
        "surfaceTotal": "174.89",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Juan XXIII 44 ",
        "postalCode": "46025",
        "lat": 39.49416009999999,
        "lng": -0.3832042000000001
    },
    {
        "id": "a07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "170.75",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.19",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.42",
        "surfaceTotal": "320.94",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Polvoranca 39 ",
        "postalCode": "28923",
        "lat": 40.341086,
        "lng": -3.8155664
    },
    {
        "id": "967fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.36",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.36",
        "surfaceTotal": "160.36",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Escultor Luis Bolinches ",
        "postalCode": "46023",
        "lat": 39.4577091,
        "lng": -0.3464715
    },
    {
        "id": "927fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.00",
        "surfaceTotal": "196.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Gasteiz 66 ",
        "postalCode": "01008",
        "lat": 42.85185070000001,
        "lng": -2.6802212
    },
    {
        "id": "aa7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1103140",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "342.04",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.18",
        "surfaceBasement1": "175.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "175.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "470.29",
        "surfaceTotal": "797.22",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Chapi 9 ",
        "postalCode": "03400",
        "lat": 38.6319733,
        "lng": -0.8657633
    },
    {
        "id": "8e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.83",
        "surfaceTotal": "156.83",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Domingo Beltran 50 ",
        "postalCode": "01012",
        "lat": 42.8538058,
        "lng": -2.6765297
    },
    {
        "id": "a47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "133.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Zamora 23 ",
        "postalCode": "47008",
        "lat": 41.6225005,
        "lng": -4.7462279
    },
    {
        "id": "9c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "360.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "284.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "392.83",
        "surfaceTotal": "644.83",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Marques De Montortal 2 ",
        "postalCode": "46019",
        "lat": 39.4922992,
        "lng": -0.3746712
    },
    {
        "id": "987fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Jaime Roig 26 ",
        "postalCode": "46010",
        "lat": 39.4834113,
        "lng": -0.3627361
    },
    {
        "id": "b67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135006",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.91",
        "surfaceTotal": "191.91",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Panchito Hernandez 8 ",
        "postalCode": "35400",
        "lat": 28.1188371,
        "lng": -15.5254307
    },
    {
        "id": "9e7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "186.62",
        "surfaceMezzanine": "0.00",
        "surfacepb": "331.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "387.36",
        "surfaceTotal": "517.99",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Regne De Valencia 2 ",
        "postalCode": "46005",
        "lat": 39.46469640000001,
        "lng": -0.3733274
    },
    {
        "id": "ae7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1110023",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "145.00",
        "surfaceTotal": "145.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Madrid 4 ",
        "postalCode": "28939",
        "lat": 40.2703682,
        "lng": -3.9193367
    },
    {
        "id": "b87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1120079",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.08",
        "surfaceTotal": "144.08",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Orape Kalea 18 ",
        "postalCode": "20800",
        "lat": 43.28585040000001,
        "lng": -2.1764572
    },
    {
        "id": "b47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1102086",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza La Orden 26 ",
        "postalCode": "02480",
        "lat": 38.3654376,
        "lng": -2.321546
    },
    {
        "id": "a67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1121010",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.40",
        "surfaceTotal": "160.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Muelle De Portugal 21 ",
        "postalCode": "21400",
        "lat": 37.2169594,
        "lng": -7.409236099999998
    },
    {
        "id": "ac7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128181",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.66",
        "surfaceTotal": "264.66",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Eras 17 ",
        "postalCode": "28670",
        "lat": 40.3580031,
        "lng": -3.9028574
    },
    {
        "id": "be7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "322.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "322.00",
        "surfaceTotal": "322.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Sagasta 80 ",
        "postalCode": "50006",
        "lat": 41.6389772,
        "lng": -0.8865126000000001
    },
    {
        "id": "b07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1106153",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "402.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "402.28",
        "surfaceTotal": "402.28",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle La Haba 17 ",
        "postalCode": "06700",
        "lat": 38.9721489,
        "lng": -5.7991673
    },
    {
        "id": "0480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.00",
        "surfaceTotal": "149.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "lat": 37.4729709,
        "lng": -4.4440773
    },
    {
        "id": "ba7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Cataluña 23 ",
        "postalCode": "50014",
        "lat": 41.6603583,
        "lng": -0.8694447999999999
    },
    {
        "id": "b27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1133076",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "75.70",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "141.27",
        "surfaceTotal": "194.26",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Balbin Busto 20 ",
        "postalCode": "33300",
        "lat": 43.4801233,
        "lng": -5.4344409
    },
    {
        "id": "a87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1129094",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Dolores Ibarruri 4 ",
        "postalCode": "29700",
        "lat": 36.7799228,
        "lng": -4.1005589
    },
    {
        "id": "d87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "148.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.00",
        "surfaceTotal": "148.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Bonanova 25 ",
        "postalCode": "08022",
        "lat": 41.4055377,
        "lng": 2.1317069
    },
    {
        "id": "d07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108015",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "43.31",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.46",
        "surfaceTotal": "130.11",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Trafalgar 8 ",
        "postalCode": "08913",
        "lat": 41.437451,
        "lng": 2.2183034
    },
    {
        "id": "ce7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1150298",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.00",
        "surfaceTotal": "88.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle San Pedro 35 ",
        "postalCode": "50800",
        "lat": 41.8683136,
        "lng": -0.7868442999999999
    },
    {
        "id": "d47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "355.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "475.79",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "582.35",
        "surfaceTotal": "830.99",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Fueros 3 ",
        "postalCode": "48901",
        "lat": 43.2962757,
        "lng": -2.9864821
    },
    {
        "id": "d27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123010",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "42.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.60",
        "surfaceTotal": "211.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Iglesia 2 ",
        "postalCode": "23710",
        "lat": 38.095725,
        "lng": -3.775174099999999
    },
    {
        "id": "f47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.67",
        "surfaceTotal": "221.67",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Sagarminaga - Archivo ",
        "postalCode": "48001",
        "lat": 43.2492132,
        "lng": -2.9127192
    },
    {
        "id": "c07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129140",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "89.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "89.00",
        "surfaceTotal": "89.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Carretera de Coín 78 ",
        "postalCode": "29140",
        "lat": 36.6585867,
        "lng": -4.4899071
    },
    {
        "id": "c87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1149275",
        "province": "49",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "311.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "311.00",
        "surfaceTotal": "311.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Feria 2 ",
        "postalCode": "49005",
        "lat": 41.50498750000001,
        "lng": -5.747899599999999
    },
    {
        "id": "cc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1145173",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "442.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "442.00",
        "surfaceTotal": "442.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Mayor 9 ",
        "postalCode": "45500",
        "lat": 39.9815465,
        "lng": -4.2841116
    },
    {
        "id": "c67fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1123079",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "113.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.50",
        "surfaceTotal": "238.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Esteban Solis 13 ",
        "postalCode": "23250",
        "lat": 38.2486767,
        "lng": -3.2068628
    },
    {
        "id": "f27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "369.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "369.00",
        "surfaceTotal": "369.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Calixto Diez 3 ",
        "postalCode": "48012",
        "lat": 43.2571298,
        "lng": -2.9412427
    },
    {
        "id": "ca7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1118021",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.40",
        "surfaceTotal": "119.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Valencia 1 ",
        "postalCode": "18100",
        "lat": 37.1437339,
        "lng": -3.6287662
    },
    {
        "id": "d67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1132009",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "140.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.47",
        "surfaceTotal": "276.78",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Marcelino Suarez 2 ",
        "postalCode": "32314",
        "lat": 42.4162109,
        "lng": -6.9815282
    },
    {
        "id": "f07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1120074",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.00",
        "surfaceTotal": "162.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo De Irizar 2 ",
        "postalCode": "20570",
        "lat": 43.1190388,
        "lng": -2.4132736
    },
    {
        "id": "e27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "90.10",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.13",
        "surfaceTotal": "180.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Santa Amelia 20 ",
        "postalCode": "08034",
        "lat": 41.3945122,
        "lng": 2.1251937
    },
    {
        "id": "bc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.20",
        "surfaceTotal": "160.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Pablo Ruiz Picasso 42 ",
        "postalCode": "50015",
        "lat": 41.673874,
        "lng": -0.8898183
    },
    {
        "id": "c27fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128007",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "261.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "261.00",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Porto Colon 14 ",
        "postalCode": "28924",
        "lat": 40.3501699,
        "lng": -3.8177118
    },
    {
        "id": "da7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135004",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "110.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.25",
        "surfaceTotal": "312.45",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Via Medular S/N ",
        "postalCode": "35500",
        "lat": 28.9620701,
        "lng": -13.5619807
    },
    {
        "id": "e47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "370.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "321.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "432.00",
        "surfaceTotal": "691.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Sicilia 284 ",
        "postalCode": "08013",
        "lat": 41.4014421,
        "lng": 2.1742113
    },
    {
        "id": "e07fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "49.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "150.32",
        "surfaceTotal": "184.75",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Republica Argentina 64 ",
        "postalCode": "08023",
        "lat": 41.4096631,
        "lng": 2.1466167
    },
    {
        "id": "ec7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108252",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "260.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "83.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.20",
        "surfaceTotal": "343.68",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Generalitat 68 ",
        "postalCode": "08210",
        "lat": 41.5153527,
        "lng": 2.1241199
    },
    {
        "id": "ee7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "244.01",
        "surfaceMezzanine": "0.00",
        "surfacepb": "250.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "323.30",
        "surfaceTotal": "494.11",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Alameda 11 ",
        "postalCode": "03501",
        "lat": 38.53603,
        "lng": -0.1298114
    },
    {
        "id": "f67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131901",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle San Esteban 9 ",
        "postalCode": "31010",
        "lat": 42.8046592,
        "lng": -1.6797765
    },
    {
        "id": "fc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1109056",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.00",
        "surfaceTotal": "84.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Justo Canton Salazar 13 ",
        "postalCode": "09240",
        "lat": 42.5508247,
        "lng": -3.3227989
    },
    {
        "id": "e67fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "88.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "119.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.50",
        "surfaceTotal": "207.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Vía Julia 154 - 158 ",
        "postalCode": "08016",
        "lat": 41.4445845,
        "lng": 2.1792516
    },
    {
        "id": "c47fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1141059",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.50",
        "surfaceTotal": "111.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida de los Descubrimientos 4 ",
        "postalCode": "41927",
        "lat": 37.3512187,
        "lng": -6.048582499999999
    },
    {
        "id": "ea7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108252",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "212.41",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.41",
        "surfaceTotal": "212.41",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Del Pla Dels Avellaners 8 ",
        "postalCode": "08210",
        "lat": 41.5279162,
        "lng": 2.1460314
    },
    {
        "id": "0080e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.62",
        "surfaceTotal": "220.62",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Reyes Catolicos 8 ",
        "postalCode": "09004",
        "lat": 42.34464879999999,
        "lng": -3.6956664
    },
    {
        "id": "de7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "323.34",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.67",
        "surfaceTotal": "323.34",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Marques De L'Argentera 3 ",
        "postalCode": "08003",
        "lat": 41.3837684,
        "lng": 2.1838838
    },
    {
        "id": "f87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146054",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "154.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "154.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Cami Nou 95 ",
        "postalCode": "46910",
        "lat": 39.421394,
        "lng": -0.3959723
    },
    {
        "id": "0280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114008",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "90.00",
        "surfaceTotal": "90.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Conde Don Alonso, 38 ",
        "postalCode": "14280",
        "lat": 38.5751273,
        "lng": -5.1656188
    },
    {
        "id": "e87fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128005",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "153.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "153.00",
        "surfaceTotal": "153.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Jose María Pereda 8 ",
        "postalCode": "28806",
        "lat": 40.4967951,
        "lng": -3.3631785
    },
    {
        "id": "dc7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "119.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "119.50",
        "surfaceTotal": "119.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Mare De Deu Montserrat 237 ",
        "postalCode": "08041",
        "lat": 41.4230007,
        "lng": 2.174962
    },
    {
        "id": "0c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146083",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "410.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "410.55",
        "surfaceTotal": "410.55",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Julian Ribera 15 ",
        "postalCode": "46740",
        "lat": 39.1215293,
        "lng": -0.4502517
    },
    {
        "id": "3080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141011",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "160.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.14",
        "surfaceTotal": "160.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Corredera 11 ",
        "postalCode": "41600",
        "lat": 37.2618651,
        "lng": -5.54582
    },
    {
        "id": "3c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114025",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "226.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.00",
        "surfaceTotal": "226.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo de Andalucia 41 ",
        "postalCode": "14830",
        "lat": 37.6789584,
        "lng": -4.5539203
    },
    {
        "id": "1480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1143037",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.91",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.91",
        "surfaceTotal": "178.91",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Monturiol 17 ",
        "postalCode": "43820",
        "lat": 41.1881735,
        "lng": 1.5731292
    },
    {
        "id": "1c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1113028",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.72",
        "surfaceTotal": "178.72",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Castillo 27 ",
        "postalCode": "13610",
        "lat": 39.4039641,
        "lng": -3.1229465
    },
    {
        "id": "0e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108046",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.23",
        "surfaceTotal": "112.23",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Doctor Ferran 1 ",
        "postalCode": "08440",
        "lat": 41.6385414,
        "lng": 2.3550459
    },
    {
        "id": "1080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108056",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "247.66",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "247.66",
        "surfaceTotal": "247.66",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Ronda Ramon Otero Pedrayo 5 ",
        "postalCode": "08860",
        "lat": 41.2866384,
        "lng": 1.9864324
    },
    {
        "id": "1a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1126036",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "149.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.70",
        "surfaceTotal": "298.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Martires 20 ",
        "postalCode": "26500",
        "lat": 42.3030481,
        "lng": -1.963867
    },
    {
        "id": "0680e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1111012",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "179.65",
        "surfaceTotal": "179.65",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Andalucia 41 ",
        "postalCode": "11007",
        "lat": 36.5210142,
        "lng": -6.2804565
    },
    {
        "id": "4080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1148034",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "116.74",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.76",
        "surfaceTotal": "233.48",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Marques De Valdespina 14 ",
        "postalCode": "48260",
        "lat": 43.1863973,
        "lng": -2.5040119
    },
    {
        "id": "1e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1118017",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "311.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "311.00",
        "surfaceTotal": "311.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Costa Del Sol 1 ",
        "postalCode": "18690",
        "lat": 36.7354223,
        "lng": -3.6913925
    },
    {
        "id": "0a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1139025",
        "province": "39",
        "CCAA": "30",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.20",
        "surfaceTotal": "140.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Cantabria 23 ",
        "postalCode": "39400",
        "lat": 43.2607047,
        "lng": -4.0691508
    },
    {
        "id": "3a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146204",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.28",
        "surfaceTotal": "130.28",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Trencall 38 ",
        "postalCode": "46540",
        "lat": 39.5878854,
        "lng": -0.3046649
    },
    {
        "id": "1680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133019",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "83.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "83.00",
        "surfaceTotal": "83.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Reconquista 10 ",
        "postalCode": "33320",
        "lat": 43.4846183,
        "lng": -5.2722394
    },
    {
        "id": "2a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.28",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.28",
        "surfaceTotal": "157.28",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida San Pablo 26 ",
        "postalCode": "28823",
        "lat": 40.436076,
        "lng": -3.5331259
    },
    {
        "id": "1880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1138001",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.58",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.58",
        "surfaceTotal": "169.58",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Helsinki- Costa Adeje SN ",
        "postalCode": "38670",
        "lat": 28.0919129,
        "lng": -16.7300036
    },
    {
        "id": "fe7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115009",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Hnos.Gcia.Naveira 23 ",
        "postalCode": "15300",
        "lat": 43.277864,
        "lng": -8.211826499999999
    },
    {
        "id": "2e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1138028",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "65.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "127.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.90",
        "surfaceTotal": "192.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Familia Betancourt y Molina ",
        "postalCode": "38400",
        "lat": 28.4166181,
        "lng": -16.5443586
    },
    {
        "id": "3680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "164.90",
        "surfaceTotal": "164.90",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Olegario Domarco Seller 73 ",
        "postalCode": "03206",
        "lat": 38.2719344,
        "lng": -0.707575
    },
    {
        "id": "fa7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1142043",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Mayor 1 ",
        "postalCode": "42300",
        "lat": 41.5873516,
        "lng": -3.0665807
    },
    {
        "id": "2480e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1117044",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "70.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "70.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.95",
        "surfaceTotal": "275.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Major 10 ",
        "postalCode": "17244",
        "lat": 41.8882393,
        "lng": 2.8754029
    },
    {
        "id": "5280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1146131",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.30",
        "surfaceTotal": "151.30",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Germanias 83 ",
        "postalCode": "46702",
        "lat": 38.9643757,
        "lng": -0.1778892
    },
    {
        "id": "3880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103066",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "303.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "267.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "357.90",
        "surfaceTotal": "570.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Dahellos 9 ",
        "postalCode": "03600",
        "lat": 38.4766925,
        "lng": -0.7939583
    },
    {
        "id": "2680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111006",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "227.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "227.00",
        "surfaceTotal": "227.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Corredera 55 ",
        "postalCode": "11630",
        "lat": 36.7501988,
        "lng": -5.8106841
    },
    {
        "id": "2c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104720",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "192.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "192.00",
        "surfaceTotal": "192.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera Malaga A Almeria, Termino De Enix ",
        "postalCode": "04720",
        "lat": 36.721261,
        "lng": -4.4212655
    },
    {
        "id": "3e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "172.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "172.00",
        "surfaceTotal": "172.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Castelao 2 ",
        "postalCode": "29004",
        "lat": 36.6920365,
        "lng": -4.4858562
    },
    {
        "id": "2880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1116078",
        "province": "16",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.93",
        "surfaceTotal": "176.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Reyes Catolicos 18 ",
        "postalCode": "16003",
        "lat": 40.0638575,
        "lng": -2.1391817
    },
    {
        "id": "0880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1112040",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.50",
        "surfaceTotal": "202.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Juez Borrull 27 ",
        "postalCode": "12003",
        "lat": 39.9838959,
        "lng": -0.0358799
    },
    {
        "id": "4a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117066",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "248.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "223.00",
        "surfaceBasement1": "104.90",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.90",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "248.80",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "350.09",
        "surfaceTotal": "576.70",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Rutlla 19 ",
        "postalCode": "17600",
        "lat": 42.26639,
        "lng": 2.96416
    },
    {
        "id": "1280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115022",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.93",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.93",
        "surfaceTotal": "178.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Castelao 17 ",
        "postalCode": "15350",
        "lat": 43.65959489999999,
        "lng": -8.0522719
    },
    {
        "id": "5e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "336.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "336.00",
        "surfaceTotal": "336.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Torre Comares S/N ",
        "postalCode": "18008",
        "lat": 37.1518768,
        "lng": -3.5946089
    },
    {
        "id": "2080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104105",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "205.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "205.00",
        "surfaceTotal": "205.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Las Negras 93 ",
        "postalCode": "04110",
        "lat": 36.9387165,
        "lng": -2.1353682
    },
    {
        "id": "3c7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1138190",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.00",
        "surfaceTotal": "113.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera General Del Sur ",
        "postalCode": "38107",
        "lat": 28.2490382,
        "lng": -16.4392596
    },
    {
        "id": "5680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146139",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Mayor 56 ",
        "postalCode": "46610",
        "lat": 39.1859001,
        "lng": -0.4773694
    },
    {
        "id": "5a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "313.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "313.00",
        "surfaceTotal": "313.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Heroe De Sostoa 148 ",
        "postalCode": "29003",
        "lat": 36.7035242,
        "lng": -4.4411739
    },
    {
        "id": "4680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.00",
        "surfaceTotal": "176.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida de Capuchinos 68 ",
        "postalCode": "29014",
        "lat": 36.7286259,
        "lng": -4.4212475
    },
    {
        "id": "6480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1126071",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.00",
        "surfaceTotal": "120.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Arrabal 4 ",
        "postalCode": "26200",
        "lat": 42.576847,
        "lng": -2.8473669
    },
    {
        "id": "4880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1115035",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "149.97",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "149.97",
        "surfaceTotal": "149.97",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Marques De Figueroa 4 ",
        "postalCode": "15500",
        "lat": 43.47492,
        "lng": -8.167449999999999
    },
    {
        "id": "4280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1131097",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "121.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "223.30",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Baja Navarra 1 ",
        "postalCode": "31200",
        "lat": 42.67177239999999,
        "lng": -2.0319014
    },
    {
        "id": "3480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "128.11",
        "surfaceTotal": "128.11",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Ilicitano Ausente 19 ",
        "postalCode": "03202",
        "lat": 38.2772175,
        "lng": -0.6783769
    },
    {
        "id": "4e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115036",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "205.76",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.00",
        "surfaceBasement1": "194.77",
        "surfaceBasement2": "176.69",
        "surfaceRest": "128.70",
        "surfacesr": "500.16",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "504.81",
        "surfaceTotal": "898.92",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Rubalcava 12 ",
        "postalCode": "15402",
        "lat": 43.4841868,
        "lng": -8.231914999999999
    },
    {
        "id": "5880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108096",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "302.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "381.73",
        "surfaceBasement1": "217.73",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "217.73",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "302.68",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "581.40",
        "surfaceTotal": "902.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Porxada 30 ",
        "postalCode": "08400",
        "lat": 41.6078513,
        "lng": 2.287441
    },
    {
        "id": "5480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103076",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.00",
        "surfaceTotal": "134.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Mayor 26 ",
        "postalCode": "03140",
        "lat": 38.0917086,
        "lng": -0.6548951
    },
    {
        "id": "5080e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1128060",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Comunidad De Madrid 2 ",
        "postalCode": "28597",
        "lat": 40.1185587,
        "lng": -3.1590147
    },
    {
        "id": "6280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148046",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "118.76",
        "surfaceTotal": "118.76",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Pablo Picasso 11 ",
        "postalCode": "48300",
        "lat": 43.3138278,
        "lng": -2.6772866
    },
    {
        "id": "5c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133024",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "261.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "261.00",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De La Costa 147 ",
        "postalCode": "33203",
        "lat": 43.5356124,
        "lng": -5.6468206
    },
    {
        "id": "6880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1122125",
        "province": "22",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.00",
        "surfaceTotal": "231.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Los Olivos 29 ",
        "postalCode": "22005",
        "lat": 42.1344258,
        "lng": -0.4048303
    },
    {
        "id": "6a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1121041",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "206.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "206.00",
        "surfaceTotal": "206.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Independencia 53 ",
        "postalCode": "21002",
        "lat": 37.2636286,
        "lng": -6.9528918
    },
    {
        "id": "6080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128065",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "203.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "219.90",
        "surfaceTotal": "362.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De España 37 ",
        "postalCode": "28903",
        "lat": 40.3140585,
        "lng": -3.7205825
    },
    {
        "id": "6680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "107.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "347.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "107.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "379.10",
        "surfaceTotal": "454.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Pedraforca 77 ",
        "postalCode": "08905",
        "lat": 41.3721711,
        "lng": 2.1095966
    },
    {
        "id": "3280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "26.00",
        "surfacepb": "144.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "26.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.71",
        "surfaceTotal": "170.71",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Zumalacarregui 9 ",
        "postalCode": "20008",
        "lat": 43.3146254,
        "lng": -2.0021516
    },
    {
        "id": "4480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Cruz De Luisa 11 ",
        "postalCode": "28945",
        "lat": 40.2836417,
        "lng": -3.7966588
    },
    {
        "id": "7480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Alcalde Perez Arda 26 ",
        "postalCode": "15008",
        "lat": 43.3506896,
        "lng": -8.4044296
    },
    {
        "id": "4c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107022",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.00",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Plaza 11 ",
        "postalCode": "07200",
        "lat": 39.4696851,
        "lng": 3.148297
    },
    {
        "id": "7080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1111020",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Paraiso Nº 4. Edificio Jerez 74 ",
        "postalCode": "11405",
        "lat": 36.6941748,
        "lng": -6.1286209
    },
    {
        "id": "7280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128035",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "50.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "60.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "80.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Joaquina De Orea 2 ",
        "lat": 40.2567602,
        "lng": -3.2376423
    },
    {
        "id": "6e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1122130",
        "province": "22",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "49.22",
        "surfacepb": "133.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "49.22",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.76",
        "surfaceTotal": "182.37",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Cortes De Aragon 6 ",
        "postalCode": "22700",
        "lat": 42.56924739999999,
        "lng": -0.551055
    },
    {
        "id": "7a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "101.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "101.00",
        "surfaceTotal": "101.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Vizcaya 1 ",
        "postalCode": "15007",
        "lat": 43.3563558,
        "lng": -8.407949799999999
    },
    {
        "id": "9280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128127",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "122.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "122.00",
        "surfaceTotal": "122.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Martin Iriarte 9 ",
        "postalCode": "28290",
        "lat": 40.5518259,
        "lng": -3.8953353
    },
    {
        "id": "a080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133700",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.50",
        "surfaceTotal": "191.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Del Pilarin 1 ",
        "postalCode": "33700",
        "lat": 43.5442928,
        "lng": -6.5352291
    },
    {
        "id": "8680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1126089",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.78",
        "surfaceTotal": "144.78",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Lardero 18 ",
        "postalCode": "26002",
        "lat": 42.4622964,
        "lng": -2.4518195
    },
    {
        "id": "9c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1123024",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "137.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "137.00",
        "surfaceTotal": "137.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Real 7 ",
        "postalCode": "23200",
        "lat": 38.2737155,
        "lng": -3.6153097
    },
    {
        "id": "8880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123055",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "135.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "341.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "381.50",
        "surfaceTotal": "476.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Corredera De San Marcos 45 ",
        "postalCode": "23700",
        "lat": 38.0975724,
        "lng": -3.6335559
    },
    {
        "id": "7680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "304.78",
        "surfaceBasement1": "101.70",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "101.70",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "355.63",
        "surfaceTotal": "406.48",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Cuesta La Palloza 1 ",
        "postalCode": "15006",
        "lat": 43.35848310000001,
        "lng": -8.403279
    },
    {
        "id": "9e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130902",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.38",
        "surfaceTotal": "152.38",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " La Luz 4 ",
        "postalCode": "30710",
        "lat": 37.7505094,
        "lng": -0.8476651
    },
    {
        "id": "8280e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.24",
        "surfaceTotal": "138.24",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle General Gutierrez Mellado 28 ",
        "postalCode": "24010",
        "lat": 42.6099784,
        "lng": -5.5931076
    },
    {
        "id": "7e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "69.79",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.82",
        "surfaceTotal": "205.67",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Los Reyes Leoneses 12 ",
        "postalCode": "24008",
        "lat": 42.6041044,
        "lng": -5.579738
    },
    {
        "id": "8080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "288.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "288.00",
        "surfaceTotal": "288.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle El Sabinar 6 ",
        "postalCode": "24007",
        "lat": 42.6041463,
        "lng": -5.5616049
    },
    {
        "id": "a880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "36.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.43",
        "surfaceTotal": "230.90",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Bravo Murillo 307 ",
        "postalCode": "28020",
        "lat": 40.4627795,
        "lng": -3.697469599999999
    },
    {
        "id": "9a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123005",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "42.21",
        "surfaceMezzanine": "0.00",
        "surfacepb": "277.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "289.76",
        "surfaceTotal": "319.31",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Ollerias 49 ",
        "postalCode": "23740",
        "lat": 38.0394192,
        "lng": -4.0546184
    },
    {
        "id": "8480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.40",
        "surfaceTotal": "166.40",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Velazquez 18 ",
        "postalCode": "24005",
        "lat": 42.59016039999999,
        "lng": -5.5675783
    },
    {
        "id": "a280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141055",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "199.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.60",
        "surfaceTotal": "199.60",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Colon 2 ",
        "postalCode": "41440",
        "lat": 37.6563259,
        "lng": -5.531469599999999
    },
    {
        "id": "8c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117092",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "68.00",
        "surfaceTotal": "68.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Major 1 ",
        "postalCode": "17490",
        "lat": 42.3624203,
        "lng": 3.1519871
    },
    {
        "id": "9480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1106011",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "138.55",
        "surfaceMezzanine": "0.00",
        "surfacepb": "268.76",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "310.33",
        "surfaceTotal": "407.31",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza de Espronceda 8 ",
        "postalCode": "06200",
        "lat": 38.6826885,
        "lng": -6.408834700000001
    },
    {
        "id": "8e80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125120",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "313.77",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "283.62",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "455.58",
        "surfaceTotal": "597.39",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Francesc Macia 37 ",
        "postalCode": "25007",
        "lat": 41.61674300000001,
        "lng": 0.6288737999999999
    },
    {
        "id": "9080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117095",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "229.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "229.00",
        "surfaceTotal": "229.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Roma Barnes 12 ",
        "postalCode": "17310",
        "lat": 41.6982113,
        "lng": 2.8456495
    },
    {
        "id": "a680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1123002",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "264.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "264.00",
        "surfaceTotal": "264.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Alamos 5 ",
        "postalCode": "23680",
        "lat": 37.4621183,
        "lng": -3.9218527
    },
    {
        "id": "7880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1115030",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.00",
        "surfaceTotal": "198.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida General Sanjurjo 121 ",
        "postalCode": "15006",
        "lat": 43.3541384,
        "lng": -8.3966005
    },
    {
        "id": "b680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.05",
        "surfaceTotal": "113.05",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Esteban Mora 43 ",
        "postalCode": "28027",
        "lat": 40.4389442,
        "lng": -3.6541609
    },
    {
        "id": "7c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.00",
        "surfaceTotal": "94.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Antonio Muñoz Zamora 2 ",
        "postalCode": "04007",
        "lat": 36.8318033,
        "lng": -2.4433269
    },
    {
        "id": "aa80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "164.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "164.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "240.20",
        "surfaceTotal": "355.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Bravo Murillo 211 ",
        "postalCode": "28020",
        "lat": 40.4558671,
        "lng": -3.7026109
    },
    {
        "id": "9880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "86.75",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.21",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.22",
        "surfaceTotal": "211.96",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Pintor Felo Monzon 27 ",
        "postalCode": "35019",
        "lat": 28.1017253,
        "lng": -15.4529491
    },
    {
        "id": "b080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "284.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "284.00",
        "surfaceTotal": "284.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Del Molino 2 ",
        "postalCode": "28045",
        "lat": 40.390001,
        "lng": -3.6934969
    },
    {
        "id": "b280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "450.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "450.00",
        "surfaceTotal": "450.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Diego De Leon 54 ",
        "postalCode": "28006",
        "lat": 40.43453290000001,
        "lng": -3.6781147
    },
    {
        "id": "ae80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1102003",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.00",
        "surfaceTotal": "158.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera De Jaen 50 ",
        "postalCode": "02006",
        "lat": 38.9928158,
        "lng": -1.8750891
    },
    {
        "id": "9680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.64",
        "surfaceTotal": "161.64",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Juan XXIII 11 ",
        "postalCode": "35004",
        "lat": 28.119035,
        "lng": -15.4260353
    },
    {
        "id": "8a80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1118122",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "280.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "280.54",
        "surfaceTotal": "280.54",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza De La Victoria, 1 ",
        "postalCode": "18300",
        "lat": 37.1671038,
        "lng": -4.1484964
    },
    {
        "id": "ac80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "420.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "344.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "420.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "470.00",
        "surfaceTotal": "764.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida De Felipe II 16 ",
        "postalCode": "28009",
        "lat": 40.4237634,
        "lng": -3.6752812
    },
    {
        "id": "6c80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120045",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "197.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.10",
        "surfaceTotal": "353.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo De Colon 27 ",
        "postalCode": "20302",
        "lat": 43.339932,
        "lng": -1.7943873
    },
    {
        "id": "be80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "19.43",
        "surfacepb": "212.30",
        "surfaceBasement1": "75.20",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "94.63",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.62",
        "surfaceTotal": "306.93",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Ps Extremadura 57 ",
        "postalCode": "28011",
        "lat": 40.4126097,
        "lng": -3.7308448
    },
    {
        "id": "ba80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1102003",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "275.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "275.10",
        "surfaceTotal": "275.10",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera De Madrid 11 ",
        "postalCode": "02006",
        "lat": 39.0043095,
        "lng": -1.8665999
    },
    {
        "id": "a480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "139.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "139.00",
        "surfaceTotal": "139.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Alameda Del Valle 34 ",
        "postalCode": "28051",
        "lat": 40.3657348,
        "lng": -3.6204652
    },
    {
        "id": "b480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "37.00",
        "surfacepb": "184.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "37.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.50",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Emilio Ferrari 24 ",
        "postalCode": "28017",
        "lat": 40.4333648,
        "lng": -3.6431764
    },
    {
        "id": "c280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "191.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.14",
        "surfaceTotal": "191.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Galileo 57 ",
        "postalCode": "28015",
        "lat": 40.4357437,
        "lng": -3.7103929
    },
    {
        "id": "c480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.50",
        "surfaceTotal": "162.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle General Ricardos 183 ",
        "postalCode": "28025",
        "lat": 40.383185,
        "lng": -3.7413564
    },
    {
        "id": "d280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "26.91",
        "surfaceMezzanine": "0.00",
        "surfacepb": "62.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "70.19",
        "surfaceTotal": "89.03",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Añastro 9 ",
        "postalCode": "28033",
        "lat": 40.4678195,
        "lng": -3.6631744
    },
    {
        "id": "ca80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "177.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "177.00",
        "surfaceTotal": "177.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Jose Del Hierro 46 ",
        "postalCode": "28027",
        "lat": 40.4396589,
        "lng": -3.6448993
    },
    {
        "id": "e080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1137171",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "126.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "126.00",
        "surfaceTotal": "126.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Mayor ",
        "postalCode": "37730",
        "lat": 40.4692583,
        "lng": -5.7207683
    },
    {
        "id": "b880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.65",
        "surfaceTotal": "130.65",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Estrella Polar 5 ",
        "postalCode": "28007",
        "lat": 40.4107432,
        "lng": -3.6673246
    },
    {
        "id": "bc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": false,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.55",
        "surfaceTotal": "194.55",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Eugenio Salazar 20 ",
        "postalCode": "28002",
        "lat": 40.4457201,
        "lng": -3.6740987
    },
    {
        "id": "ce80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "465.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "365.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "504.50",
        "surfaceTotal": "830.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Plaza Magdalena 9 ",
        "postalCode": "41001",
        "lat": 37.3914147,
        "lng": -5.9972014
    },
    {
        "id": "d480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "173.60",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "225.68",
        "surfaceTotal": "347.20",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Doctor Esquerdo 197 ",
        "postalCode": "28007",
        "lat": 40.402909,
        "lng": -3.6728215
    },
    {
        "id": "e480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117023",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "181.06",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.06",
        "surfaceTotal": "181.06",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera Malgrat 3 ",
        "postalCode": "17300",
        "lat": 41.6763348,
        "lng": 2.7801
    },
    {
        "id": "cc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "217.14",
        "surfaceTotal": "217.14",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Paseo Almeria 52 ",
        "postalCode": "04001",
        "lat": 36.8375162,
        "lng": -2.4633884
    },
    {
        "id": "c880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1102003",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "201.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.32",
        "surfaceTotal": "201.32",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Perez Galdos 25 ",
        "postalCode": "02003",
        "lat": 38.9904888,
        "lng": -1.8596976
    },
    {
        "id": "d880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1102015",
        "province": "02",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.34",
        "surfaceTotal": "115.34",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Manuel Lodares 5 ",
        "postalCode": "02639",
        "lat": 39.0452356,
        "lng": -2.2009957
    },
    {
        "id": "c680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.35",
        "surfaceTotal": "198.35",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Halcon 2 ",
        "postalCode": "28025",
        "lat": 40.3896954,
        "lng": -3.7427552
    },
    {
        "id": "dc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133041",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.05",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.05",
        "surfaceTotal": "74.05",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle La Botica ",
        "postalCode": "33790",
        "lat": 43.53975210000001,
        "lng": -6.724565200000001
    },
    {
        "id": "f880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1143148",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.50",
        "surfaceTotal": "166.50",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Veinte 74 ",
        "postalCode": "43100",
        "lat": 41.1188827,
        "lng": 1.2444909
    },
    {
        "id": "fa80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1134055",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "61.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "61.20",
        "surfaceTotal": "61.20",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Torogil 5 ",
        "postalCode": "34309",
        "lat": 42.2905776,
        "lng": -4.769805799999999
    },
    {
        "id": "c080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "167.65",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.83",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.13",
        "surfaceTotal": "354.48",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Francisco Silvela 53 ",
        "postalCode": "28028",
        "lat": 40.4337254,
        "lng": -3.6739358
    },
    {
        "id": "ee80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1147175",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "139.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "211.70",
        "surfaceTotal": "309.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Mayor 25 ",
        "postalCode": "47320",
        "lat": 41.5843293,
        "lng": -4.5811439
    },
    {
        "id": "0681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "139.23",
        "surfaceMezzanine": "0.00",
        "surfacepb": "118.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.49",
        "surfaceTotal": "257.95",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Oña 69 ",
        "postalCode": "28050",
        "lat": 40.4892055,
        "lng": -3.6638286
    },
    {
        "id": "ec80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146203",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.17",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "168.36",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "259.35",
        "surfaceTotal": "343.53",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera Nou 24 ",
        "postalCode": "46670",
        "lat": 39.085908,
        "lng": -0.4768685
    },
    {
        "id": "e680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1138040",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Avenida Marítima 37 ",
        "postalCode": "38040",
        "lat": 28.2972603,
        "lng": -16.8156254
    },
    {
        "id": "e880e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1119130",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "152.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.00",
        "surfaceTotal": "152.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Mago De Oz 7 ",
        "postalCode": "19005",
        "lat": 40.64141,
        "lng": -3.1505899
    },
    {
        "id": "da80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1126005",
        "province": "26",
        "CCAA": "20",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " Santa Isabel 2 ",
        "postalCode": "26002",
        "lat": 42.3574908,
        "lng": -2.4734555
    },
    {
        "id": "fe80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1136051",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Progreso-Portonovo 53 ",
        "postalCode": "36970",
        "lat": 42.3938153,
        "lng": -8.8246901
    },
    {
        "id": "1a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1131053",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.00",
        "surfaceTotal": "103.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Constitución 2 ",
        "postalCode": "31252",
        "lat": 42.5264213,
        "lng": -1.834649
    },
    {
        "id": "1681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146065",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Nave industrial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1843.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1843.00",
        "surfaceTotal": "1843.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Alqueria 10 ",
        "postalCode": "46469",
        "lat": 39.4014761,
        "lng": -0.400742
    },
    {
        "id": "0081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1118158",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.00",
        "surfaceTotal": "124.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Real 206 ",
        "postalCode": "18240",
        "lat": 37.2514515,
        "lng": -3.7496132
    },
    {
        "id": "f280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114018",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.68",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "82.68",
        "surfaceTotal": "82.68",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza De La Constitucion 7 ",
        "postalCode": "14620",
        "lat": 37.9401584,
        "lng": -4.499105
    },
    {
        "id": "f480e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128170",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "77.02",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "77.02",
        "surfaceTotal": "77.02",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Alamillo 18 ",
        "postalCode": "28360",
        "lat": 40.103189,
        "lng": -3.4845413
    },
    {
        "id": "0a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "104.20",
        "surfaceMezzanine": "0.00",
        "surfacepb": "66.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "97.46",
        "surfaceTotal": "170.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Travesía De Vigo 99 ",
        "postalCode": "36207",
        "lat": 42.2380807,
        "lng": -8.7037669
    },
    {
        "id": "de80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "235.85",
        "surfaceMezzanine": "0.00",
        "surfacepb": "51.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "121.76",
        "surfaceTotal": "286.85",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Principe de Vergara 206 ",
        "postalCode": "28002",
        "lat": 40.4501524,
        "lng": -3.677258799999999
    },
    {
        "id": "0881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "258.86",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.20",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "148.94",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "315.33",
        "surfaceTotal": "571.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Betanzos 72-74 ",
        "postalCode": "28034",
        "lat": 40.4822531,
        "lng": -3.7135222
    },
    {
        "id": "d080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1141082",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.50",
        "surfaceTotal": "96.50",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Cervantes 4 ",
        "postalCode": "41590",
        "lat": 37.1997958,
        "lng": -4.780192599999999
    },
    {
        "id": "0c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141102",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "112.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "56.00",
        "surfaceTotal": "112.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Corredera 53 ",
        "postalCode": "41520",
        "lat": 37.3866565,
        "lng": -5.7229277
    },
    {
        "id": "f680e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "327.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "327.00",
        "surfaceTotal": "327.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Alejandro Soler 2 ",
        "postalCode": "46003",
        "lat": 39.4699075,
        "lng": -0.3762881
    },
    {
        "id": "1081e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "113.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "113.00",
        "surfaceTotal": "113.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Comandante Fortea 32 ",
        "postalCode": "28008",
        "lat": 40.4264504,
        "lng": -3.7310792
    },
    {
        "id": "ea80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "240.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "444.00",
        "surfaceTotal": "564.00",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": " General Vives 55 - 57 ",
        "postalCode": "35007",
        "lat": 28.1392053,
        "lng": -15.4314069
    },
    {
        "id": "e280e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117022",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "77.71",
        "surfacepb": "92.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "77.71",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.11",
        "surfaceTotal": "169.96",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Calle Les Voltes 15-17 ",
        "postalCode": "17100",
        "lat": 41.9610576,
        "lng": 3.0389344
    },
    {
        "id": "1c81e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "59.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "59.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "59.00",
        "surfaceTotal": "59.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De Barcelona 42 ",
        "postalCode": "29009",
        "lat": 36.7258541,
        "lng": -4.430629
    },
    {
        "id": "0281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "81.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "122.60",
        "surfaceTotal": "179.30",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Vía Carpetana 81 ",
        "postalCode": "28047",
        "lat": 40.3960471,
        "lng": -3.7375782
    },
    {
        "id": "f080e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1132032",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "101.41",
        "surfacepb": "137.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "101.41",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.06",
        "surfaceTotal": "238.76",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De Madrid 16 ",
        "postalCode": "32630",
        "lat": 42.0622372,
        "lng": -7.7244213
    },
    {
        "id": "2481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117079",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.81",
        "surfaceTotal": "161.81",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Paseo De Olot s/n ",
        "postalCode": "17005",
        "lat": 41.97636,
        "lng": 2.8088664
    },
    {
        "id": "1481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "398.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "491.43",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "610.83",
        "surfaceTotal": "889.43",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Luca De Tena 7 ",
        "postalCode": "28045",
        "lat": 40.40131179999999,
        "lng": -3.6933482
    },
    {
        "id": "3881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "217.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "217.00",
        "surfaceTotal": "217.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De La Industria 18 ",
        "postalCode": "28947",
        "lat": 40.27131809999999,
        "lng": -3.7630183
    },
    {
        "id": "2881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1101059",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Cola Y Goiti 9 ",
        "postalCode": "01003",
        "lat": 42.8471653,
        "lng": -2.6635581
    },
    {
        "id": "1281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1133002",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "234.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.00",
        "surfaceTotal": "234.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Constitucion 16 ",
        "postalCode": "33678",
        "lat": 43.1686978,
        "lng": -5.737428200000001
    },
    {
        "id": "3281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Pendiente validación técnica",
        "strategy": "ALQUILER",
        "city": "1108121",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.00",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Figuera Major, 45 ",
        "postalCode": "08304",
        "lat": 41.5534865,
        "lng": 2.4414554
    },
    {
        "id": "0e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114035",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "100.00",
        "surfaceTotal": "100.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Corredera 24 ",
        "postalCode": "14270",
        "lat": 38.4992686,
        "lng": -5.1463629
    },
    {
        "id": "2c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1124183",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.72",
        "surfaceTotal": "116.72",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Carretera De Almarza 1 ",
        "postalCode": "24880",
        "lat": 42.815659,
        "lng": -4.9472647
    },
    {
        "id": "3c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "99.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "99.18",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.97",
        "surfaceTotal": "173.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Borbon 70 ",
        "postalCode": "08003",
        "lat": 41.4288834,
        "lng": 2.174672
    },
    {
        "id": "3e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108279",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "305.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "305.65",
        "surfaceTotal": "305.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Carretera De Matadepera 195-203 ",
        "postalCode": "08225",
        "lat": 41.5755908,
        "lng": 2.0170177
    },
    {
        "id": "2e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "138.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "138.00",
        "surfaceTotal": "138.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Eustasio Amilibia 10 ",
        "postalCode": "20011",
        "lat": 43.3052458,
        "lng": -1.9779963
    },
    {
        "id": "2081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "255.51",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "255.51",
        "surfaceTotal": "255.51",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Conjunto Playa Virginia 7 ",
        "postalCode": "29018",
        "lat": 36.7178702,
        "lng": -4.3493501
    },
    {
        "id": "0481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "90.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "90.38",
        "surfaceTotal": "90.38",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Paseo De Los Castellanos, 65 65 ",
        "postalCode": "28025",
        "lat": 40.37465419999999,
        "lng": -3.7429008
    },
    {
        "id": "2a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1118158",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "162.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.00",
        "surfaceTotal": "162.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Real 103-105 ",
        "postalCode": "18240",
        "lat": 37.2503296,
        "lng": -3.756366
    },
    {
        "id": "3681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.00",
        "surfaceTotal": "140.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Constitucion 207 ",
        "postalCode": "28850",
        "lat": 40.4605862,
        "lng": -3.458222
    },
    {
        "id": "2281e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1138011",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "56.00",
        "surfacepb": "405.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "56.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "433.00",
        "surfaceTotal": "461.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Polig. Ind. Valle De Güimar ",
        "postalCode": "38500",
        "lat": 28.3557192,
        "lng": -16.3719006
    },
    {
        "id": "1e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1145168",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "171.00",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Santa Fe 4 ",
        "postalCode": "45001",
        "lat": 39.859383,
        "lng": -4.0207035
    },
    {
        "id": "2681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "107.74",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.42",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.74",
        "surfaceTotal": "233.16",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Aragon 127 ",
        "postalCode": "07005",
        "lat": 39.580887,
        "lng": 2.6660445
    },
    {
        "id": "1881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1123.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1123.22",
        "surfaceTotal": "1123.22",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Salvador Manrique De Lara S/N ",
        "postalCode": "35010",
        "lat": 28.1309773,
        "lng": -15.4360929
    },
    {
        "id": "4281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1152001",
        "province": "52",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.04",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.04",
        "surfaceTotal": "134.04",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " La Legion 6-8 ",
        "postalCode": "52001",
        "lat": 35.2922775,
        "lng": -2.9380973
    },
    {
        "id": "5c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108096",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "134.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "134.00",
        "surfaceTotal": "134.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Joan Prim 131-139 ",
        "postalCode": "08401",
        "lat": 41.6130449,
        "lng": 2.2899545
    },
    {
        "id": "fc80e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108217",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "136.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "136.00",
        "surfaceTotal": "136.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Major 72 ",
        "postalCode": "08970",
        "lat": 41.3673523,
        "lng": 2.0566806
    },
    {
        "id": "3081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "329.28",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.89",
        "surfaceTotal": "449.39",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " San Francisco 25 ",
        "postalCode": "20001",
        "lat": 43.3247131,
        "lng": -1.972894
    },
    {
        "id": "4881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114010",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.00",
        "surfaceTotal": "115.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Juan Jose Espejo 37 ",
        "postalCode": "14910",
        "lat": 37.2682631,
        "lng": -4.5400216
    },
    {
        "id": "4e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114074",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "102.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "102.00",
        "surfaceTotal": "102.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Iglesias 10 ",
        "postalCode": "14470",
        "lat": 40.6647768,
        "lng": -4.0385925
    },
    {
        "id": "4081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146084",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "86.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "86.00",
        "surfaceTotal": "86.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Valencia 12 ",
        "postalCode": "46294",
        "lat": 39.0674417,
        "lng": -0.5667420000000001
    },
    {
        "id": "3a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.00",
        "surfaceTotal": "156.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Paseo Santa Lucia 103 ",
        "postalCode": "31012",
        "lat": 42.8251266,
        "lng": -1.6680639
    },
    {
        "id": "5a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128127",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.00",
        "surfaceTotal": "96.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Wisterra 6 ",
        "postalCode": "28232",
        "lat": 40.5166415,
        "lng": -3.9252661
    },
    {
        "id": "5081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124115",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "247.44",
        "surfaceMezzanine": "0.00",
        "surfacepb": "236.72",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "310.95",
        "surfaceTotal": "484.16",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Paseo De La Rosaleda ",
        "postalCode": "24400",
        "lat": 42.5499958,
        "lng": -6.598259000000001
    },
    {
        "id": "4681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1119151",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "99.48",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "99.48",
        "surfaceTotal": "99.48",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Olivo 4 ",
        "postalCode": "28970",
        "lat": 40.2530078,
        "lng": -3.8289902
    },
    {
        "id": "6281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "182.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.98",
        "surfaceTotal": "182.98",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Quevedo 33 ",
        "postalCode": "24009",
        "lat": 42.5995521,
        "lng": -5.5870421
    },
    {
        "id": "5681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.00",
        "surfaceTotal": "189.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle General Concha 22 ",
        "postalCode": "48010",
        "lat": 43.2585428,
        "lng": -2.935446900000001
    },
    {
        "id": "6081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "132.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "132.65",
        "surfaceTotal": "132.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Almeria 14 ",
        "postalCode": "29018",
        "lat": 36.720881,
        "lng": -4.3586681
    },
    {
        "id": "5281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "city": "1138011",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.40",
        "surfaceTotal": "120.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Rambla de los Menceyes 14 ",
        "postalCode": "38530",
        "lat": 28.3666212,
        "lng": -16.3656881
    },
    {
        "id": "4481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108163",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "110.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "133.00",
        "surfaceTotal": "210.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Jacinto Verdaguer 32 ",
        "postalCode": "08397",
        "lat": 41.6252839,
        "lng": 2.686147
    },
    {
        "id": "5881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Joaquín Chapaprieta 148 ",
        "postalCode": "03183",
        "lat": 37.9842923,
        "lng": -0.6814821000000001
    },
    {
        "id": "5e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "375.00",
        "surfaceBasement1": "161.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "161.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "455.50",
        "surfaceTotal": "536.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Travessera De Dalt 117-119 ",
        "postalCode": "08024",
        "lat": 41.412135,
        "lng": 2.1586365
    },
    {
        "id": "6a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108102",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "293.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "293.00",
        "surfaceTotal": "293.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Barcelona 176 ",
        "postalCode": "08700",
        "lat": 41.5833646,
        "lng": 1.6277535
    },
    {
        "id": "7481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.50",
        "surfaceTotal": "112.50",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Argentina 2 ",
        "postalCode": "28918",
        "lat": 40.3319506,
        "lng": -3.7686545
    },
    {
        "id": "5481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.24",
        "surfaceTotal": "166.24",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Carlos Iii, 45 ",
        "postalCode": "14014",
        "lat": 37.8969105,
        "lng": -4.757874
    },
    {
        "id": "6681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108169",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "220.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "220.00",
        "surfaceTotal": "220.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Bruguers 22 ",
        "postalCode": "08820",
        "lat": 41.3227154,
        "lng": 2.0873004
    },
    {
        "id": "8c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104100",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "86.56",
        "surfaceMezzanine": "0.00",
        "surfacepb": "129.50",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "409.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "360.17",
        "surfaceTotal": "625.46",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Mayor 2 ",
        "postalCode": "04620",
        "lat": 37.2475062,
        "lng": -1.8693933
    },
    {
        "id": "6e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108187",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "78.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "52.48",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.71",
        "surfaceTotal": "130.95",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Calassanç Duran 12-18 ",
        "postalCode": "08203",
        "lat": 41.5394053,
        "lng": 2.113271
    },
    {
        "id": "8281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1103099",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "135.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.25",
        "surfaceTotal": "380.99",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Alhambra ",
        "postalCode": "03189",
        "lat": 37.92728,
        "lng": -0.7281107
    },
    {
        "id": "7881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1148002",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.00",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Minero Hiribidea 42 ",
        "postalCode": "48500",
        "lat": 43.3147106,
        "lng": -3.0737145
    },
    {
        "id": "8a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.00",
        "surfaceTotal": "146.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Juan Carlos I 86 ",
        "postalCode": "28916",
        "lat": 40.3319506,
        "lng": -3.7686545
    },
    {
        "id": "9081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "152.68",
        "surfaceMezzanine": "0.00",
        "surfacepb": "145.79",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "191.59",
        "surfaceTotal": "298.47",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Joaquin Chapaprieta 13 ",
        "postalCode": "03181",
        "lat": 37.97705250000001,
        "lng": -0.681252
    },
    {
        "id": "9681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Okupado",
        "strategy": "VENTA",
        "city": "1145077",
        "province": "45",
        "CCAA": "40",
        "country": "ES",
        "use": "Nave industrial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "1500.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1500.00",
        "surfaceTotal": "1500.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Zurbarán 4 ",
        "postalCode": "45511",
        "lat": 40.0289173,
        "lng": -4.2013851
    },
    {
        "id": "7081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1138043",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "339.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "339.00",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Carretera General Del Norte 63 ",
        "postalCode": "38350",
        "lat": 28.4775,
        "lng": -16.41298
    },
    {
        "id": "9e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103133",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.00",
        "surfaceTotal": "159.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Habaneras 83 ",
        "postalCode": "03182",
        "lat": 37.9805576,
        "lng": -0.6688367
    },
    {
        "id": "8481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1106138",
        "province": "06",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "178.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "178.40",
        "surfaceTotal": "178.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De Los Emigrantes 9 ",
        "postalCode": "06474",
        "lat": 38.9142511,
        "lng": -6.0690257
    },
    {
        "id": "8681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128038",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Centro Formación",
        "surfacebr": "739.04",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "7418.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3930.76",
        "surfaceTotal": "8157.14",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Carretera Dehesas A Fuenfria ",
        "postalCode": "28470",
        "lat": 40.7553233,
        "lng": -4.0707656
    },
    {
        "id": "7281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "66.62",
        "surfaceMezzanine": "0.00",
        "surfacepb": "68.03",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "88.02",
        "surfaceTotal": "134.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Minerva 15 ",
        "postalCode": "28032",
        "lat": 40.4032366,
        "lng": -3.5984222
    },
    {
        "id": "9281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128148",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.00",
        "surfaceTotal": "151.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Circunvalacion 6 ",
        "postalCode": "28850",
        "lat": 40.4500095,
        "lng": -3.4626024
    },
    {
        "id": "a681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146131",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.00",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Cardenal Sanz Y Flores 4 ",
        "postalCode": "46701",
        "lat": 38.968032,
        "lng": -0.1844671
    },
    {
        "id": "6481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "120.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "120.53",
        "surfaceTotal": "120.53",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Puente De La Reina ",
        "postalCode": "28050",
        "lat": 40.5021166,
        "lng": -3.6742316
    },
    {
        "id": "8881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1141045",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.00",
        "surfaceTotal": "110.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Hermanos Machado 21 ",
        "postalCode": "41860",
        "lat": 37.5266902,
        "lng": -6.155968
    },
    {
        "id": "4a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108089",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "95.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "95.00",
        "surfaceTotal": "95.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Mestre Falla 5 ",
        "postalCode": "08850",
        "lat": 41.41623740000001,
        "lng": 1.9982279
    },
    {
        "id": "7681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108217",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.00",
        "surfaceTotal": "104.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Sant Boi De Llobregat 2 ",
        "postalCode": "08970",
        "lat": 41.3686541,
        "lng": 2.0731263
    },
    {
        "id": "7e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108219",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.38",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.38",
        "surfaceTotal": "203.38",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Escultor Monjo 13-14-15 ",
        "postalCode": "08340",
        "lat": 41.50238969999999,
        "lng": 2.3906641
    },
    {
        "id": "6c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108196",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "65.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "28.30",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "79.75",
        "surfaceTotal": "93.90",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Cataluña 1 ",
        "postalCode": "08740",
        "lat": 41.4491478,
        "lng": 1.9724424
    },
    {
        "id": "7a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1112040",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Paseo Buenavista 30 ",
        "postalCode": "12100",
        "lat": 39.9736826,
        "lng": 0.0147038
    },
    {
        "id": "9a81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1103128",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "223.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "223.00",
        "surfaceTotal": "223.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Carretera De Moraira A Calpe 1221 ",
        "postalCode": "03725",
        "lat": 38.6826531,
        "lng": 0.1216822
    },
    {
        "id": "9481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1113009",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "50.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "75.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.50",
        "surfaceTotal": "125.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Real 118 ",
        "postalCode": "13380",
        "lat": 38.7366259,
        "lng": -3.8398265
    },
    {
        "id": "8e81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129032",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "66.02",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.79",
        "surfaceTotal": "259.80",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle San Benito 11 ",
        "postalCode": "29320",
        "lat": 37.049943,
        "lng": -4.862125
    },
    {
        "id": "9c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "231.61",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "231.61",
        "surfaceTotal": "231.61",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Fco. Salzillo s/n ",
        "postalCode": "30166",
        "lat": 37.9707225,
        "lng": -1.1729433
    },
    {
        "id": "a881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "65.66",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "253.83",
        "surfaceTotal": "286.66",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Luchana 31 ",
        "postalCode": "28010",
        "lat": 40.4320457,
        "lng": -3.6986493
    },
    {
        "id": "ac81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "300.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "300.45",
        "surfaceTotal": "300.45",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Verdiales 17 ",
        "postalCode": "18014",
        "lat": 37.1957684,
        "lng": -3.6119688
    },
    {
        "id": "8081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108307",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "103.64",
        "surfaceTotal": "103.64",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza De La Era 2 ",
        "postalCode": "08800",
        "lat": 41.2151504,
        "lng": 1.727446
    },
    {
        "id": "56845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "187.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "187.60",
        "surfaceTotal": "187.60",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "lat": 37.6979035,
        "lng": -5.2821294
    },
    {
        "id": "b281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108266",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.00",
        "surfaceTotal": "157.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Sant Iscle 23 ",
        "postalCode": "08290",
        "lat": 41.4899701,
        "lng": 2.1440578
    },
    {
        "id": "a081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108136",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.00",
        "surfaceTotal": "123.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Onze De Setembre 26 ",
        "postalCode": "08170",
        "lat": 41.5445244,
        "lng": 2.2670286
    },
    {
        "id": "aa81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128058",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "245.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "245.00",
        "surfaceTotal": "245.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Constitución 22 ",
        "postalCode": "28944",
        "lat": 40.281795,
        "lng": -3.7887908
    },
    {
        "id": "b481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1133747",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.00",
        "surfaceTotal": "130.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Alcalde Jose Fernandin 6 ",
        "postalCode": "33450",
        "lat": 43.5601305,
        "lng": -5.974206199999999
    },
    {
        "id": "ba81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1124038",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "116.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "116.00",
        "surfaceTotal": "116.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle San Roque 22 ",
        "postalCode": "24549",
        "lat": 42.5563387,
        "lng": -6.7306836
    },
    {
        "id": "9881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120069",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.00",
        "surfaceTotal": "74.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Eguia 7 ",
        "postalCode": "20012",
        "lat": 43.3166859,
        "lng": -1.9734361
    },
    {
        "id": "c881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1129067",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "179.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "179.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "268.50",
        "surfaceTotal": "358.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Gerald Brenan 62 ",
        "postalCode": "29004",
        "lat": 36.6909544,
        "lng": -4.4769311
    },
    {
        "id": "c481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "333.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "333.12",
        "surfaceTotal": "333.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Ollerias 37 ",
        "postalCode": "14001",
        "lat": 37.892667,
        "lng": -4.7720386
    },
    {
        "id": "7c81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "212.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "212.00",
        "surfaceTotal": "212.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Rua Das Teixugueiras ",
        "postalCode": "36212",
        "lat": 42.2117667,
        "lng": -8.7547704
    },
    {
        "id": "c681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108279",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "199.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "199.00",
        "surfaceTotal": "199.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Prior Tapia 19 ",
        "postalCode": "08222",
        "lat": 41.5618626,
        "lng": 2.0203784
    },
    {
        "id": "a281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104902",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "235.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "235.00",
        "surfaceTotal": "235.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Santa Maria Del Aguila 36 ",
        "postalCode": "04700",
        "lat": 36.7795637,
        "lng": -2.7750424
    },
    {
        "id": "c081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "398.34",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "398.34",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "405.80",
        "surfaceTotal": "684.64",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Alcalde Ramirez Bethencourt 17 ",
        "postalCode": "35004",
        "lat": 28.1168518,
        "lng": -15.4202617
    },
    {
        "id": "be81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1129051",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.12",
        "surfaceTotal": "110.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida España 3 ",
        "postalCode": "29680",
        "lat": 36.4256875,
        "lng": -5.1431323
    },
    {
        "id": "bc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.29",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "194.29",
        "surfaceTotal": "194.29",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Rincon De Ademuz 29 ",
        "postalCode": "46018",
        "lat": 39.47061009999999,
        "lng": -0.402506
    },
    {
        "id": "0e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103063",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "214.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "214.30",
        "surfaceTotal": "214.30",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Campo Torres 37 ",
        "postalCode": "03700",
        "lat": 38.838625,
        "lng": 0.1000138
    },
    {
        "id": "a481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128134",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "29.17",
        "surfaceMezzanine": "0.00",
        "surfacepb": "102.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.63",
        "surfaceTotal": "132.05",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Alonso Zamora Vicente, 6 ",
        "postalCode": "28703",
        "lat": 40.5634825,
        "lng": -3.6112134
    },
    {
        "id": "ca81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "208.64",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "208.64",
        "surfaceTotal": "208.64",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Candilejas 72-74 ",
        "postalCode": "28005",
        "lat": 40.3817121,
        "lng": -3.664822
    },
    {
        "id": "e681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108015",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.10",
        "surfaceTotal": "155.10",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Mozart 17 ",
        "postalCode": "08914",
        "lat": 41.4545716,
        "lng": 2.2172681
    },
    {
        "id": "e081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1117009",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "53.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "149.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "127.50",
        "surfaceTotal": "202.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Francesc Camprodon 23 ",
        "postalCode": "17401",
        "lat": 41.8161558,
        "lng": 2.5153255
    },
    {
        "id": "d281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103009",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.67",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.67",
        "surfaceTotal": "161.67",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Hispanidad 55 ",
        "postalCode": "03800",
        "lat": 38.7087698,
        "lng": -0.4650173
    },
    {
        "id": "b881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107015",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "97.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "97.00",
        "surfaceTotal": "97.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Cami De Mao, 153 ",
        "postalCode": "07760",
        "lat": 40.00403499999999,
        "lng": 3.8467481
    },
    {
        "id": "ae81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "city": "1148013",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.81",
        "surfaceTotal": "144.81",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Resureccion Maria De Azkue 43 ",
        "postalCode": "48902",
        "lat": 43.3081881,
        "lng": -3.0028928
    },
    {
        "id": "b081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.56",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.56",
        "surfaceTotal": "107.56",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Paisos Catalans 41 - 43 ",
        "postalCode": "43206",
        "lat": 41.1539413,
        "lng": 1.0971255
    },
    {
        "id": "dc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1101002",
        "province": "01",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.86",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.86",
        "surfaceTotal": "161.86",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Jose De Madinabeitia 14 ",
        "postalCode": "01470",
        "lat": 43.0513944,
        "lng": -3.0028396
    },
    {
        "id": "da81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125021",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "157.99",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "157.99",
        "surfaceTotal": "157.99",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De Lleida 61 ",
        "postalCode": "25126",
        "lat": 41.7973638,
        "lng": 0.5699344
    },
    {
        "id": "d481e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1104902",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "84.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "84.00",
        "surfaceTotal": "84.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Canoa 9 ",
        "postalCode": "04711",
        "lat": 36.696896,
        "lng": -2.7898465
    },
    {
        "id": "de81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1103018",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "168.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "168.94",
        "surfaceTotal": "168.94",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " La Mar 159 ",
        "postalCode": "03590",
        "lat": 38.592994,
        "lng": -0.05553900000000001
    },
    {
        "id": "ec81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1120074",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "169.15",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "169.15",
        "surfaceTotal": "169.15",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Ibargarai 26 ",
        "postalCode": "20570",
        "lat": 43.1164119,
        "lng": -2.4160708
    },
    {
        "id": "d681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1146013",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "295.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "295.85",
        "surfaceTotal": "295.85",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De La Horchata 24 ",
        "postalCode": "46120",
        "lat": 39.4989552,
        "lng": -0.3510141
    },
    {
        "id": "c281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108200",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "361.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "361.00",
        "surfaceTotal": "361.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Antonio Gaudi 54 ",
        "postalCode": "08830",
        "lat": 41.3487538,
        "lng": 2.030067
    },
    {
        "id": "e281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1125041",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "75.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "75.45",
        "surfaceTotal": "75.45",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Domenech Cardenal 36 ",
        "postalCode": "25262",
        "lat": 41.67701,
        "lng": 1.01722
    },
    {
        "id": "e881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "99.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.50",
        "surfaceTotal": "209.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Rosari 45 ",
        "postalCode": "08017",
        "lat": 41.3981421,
        "lng": 2.1320788
    },
    {
        "id": "d881e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1125016",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "143.84",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "143.84",
        "surfaceTotal": "143.84",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Jaume Nadal, 1bis ",
        "postalCode": "25125",
        "lat": 41.73593,
        "lng": 0.58421
    },
    {
        "id": "ea81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "340.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "340.00",
        "surfaceTotal": "340.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Diagonal 311 ",
        "postalCode": "08029",
        "lat": 41.3994999,
        "lng": 2.1729962
    },
    {
        "id": "b681e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117180",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "292.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "292.60",
        "surfaceTotal": "292.60",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle San Sebastian 13-19 ",
        "postalCode": "17430",
        "lat": 41.8624336,
        "lng": 2.6650879
    },
    {
        "id": "f681e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1110032",
        "province": "10",
        "CCAA": "41",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.65",
        "surfaceTotal": "111.65",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza De Ovando 20 ",
        "postalCode": "10950",
        "lat": 39.6127096,
        "lng": -6.7781444
    },
    {
        "id": "0082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108056",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "190.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "190.00",
        "surfaceTotal": "190.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Llibertat 8 ",
        "postalCode": "08860",
        "lat": 41.2789061,
        "lng": 1.9767421
    },
    {
        "id": "f881e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1123012",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "82.13",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "82.13",
        "surfaceTotal": "82.13",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Paseo De La Constitucion 32 ",
        "postalCode": "23280",
        "lat": 38.2534703,
        "lng": -2.8888912
    },
    {
        "id": "fc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1129649",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "108.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "108.00",
        "surfaceTotal": "108.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle San Wenceslao de Calypso 28 ",
        "postalCode": "29649",
        "lat": 36.4895257,
        "lng": -4.7143593
    },
    {
        "id": "fe81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1146083",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "198.78",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "198.78",
        "surfaceTotal": "198.78",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Julian Ribera 27 ",
        "postalCode": "46740",
        "lat": 39.1214888,
        "lng": -0.4497762
    },
    {
        "id": "0482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "city": "1124056",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "107.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "107.00",
        "surfaceTotal": "107.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De La Constitucion 87 ",
        "postalCode": "24800",
        "lat": 42.8028971,
        "lng": -5.1277548
    },
    {
        "id": "f481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1112032",
        "province": "12",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "140.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "210.00",
        "surfaceTotal": "280.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Menendez Y Pelayo 2 ",
        "postalCode": "12530",
        "lat": 39.8890151,
        "lng": -0.0865406
    },
    {
        "id": "ee81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "VENTA",
        "city": "1148020",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Oficina",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "1062.44",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "1062.44",
        "surfaceTotal": "1062.44",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Gran Via Don Diego Lope De Haro 17 ",
        "postalCode": "48001",
        "lat": 43.2633324,
        "lng": -2.9364132
    },
    {
        "id": "0a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141034",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "239.44",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "239.44",
        "surfaceTotal": "239.44",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Cervantes 70 ",
        "postalCode": "41100",
        "lat": 37.2841986,
        "lng": -6.052636
    },
    {
        "id": "fa81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "city": "1125052",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "117.01",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "117.01",
        "surfaceTotal": "117.01",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Verge De Les Sogues 1 ",
        "postalCode": "25142",
        "lat": 41.672876,
        "lng": 0.8178133000000001
    },
    {
        "id": "0282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111015",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "359.85",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "359.85",
        "surfaceTotal": "359.85",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Fuente 44905 ",
        "postalCode": "11130",
        "lat": 36.4206001,
        "lng": -6.146621
    },
    {
        "id": "1082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "170.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Charles Darwin 6 ",
        "postalCode": "03203",
        "lat": 38.2922661,
        "lng": -0.6095290999999999
    },
    {
        "id": "e481e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108015",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "149.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "444.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.70",
        "surfaceTotal": "593.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Layret 1 ",
        "postalCode": "08911",
        "lat": 41.44950679999999,
        "lng": 2.2460688
    },
    {
        "id": "1882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107022",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "221.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.50",
        "surfaceTotal": "221.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Hospici 7 ",
        "postalCode": "07200",
        "lat": 39.4694903,
        "lng": 3.1505961
    },
    {
        "id": "f081e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1142043",
        "province": "42",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "35.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "100.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "35.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.50",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Mayor 14 ",
        "postalCode": "42300",
        "lat": 41.5869028,
        "lng": -3.0677644
    },
    {
        "id": "2682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1131122",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.54",
        "surfaceTotal": "161.54",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Zubiarte 33 ",
        "postalCode": "31620",
        "lat": 42.8319895,
        "lng": -1.5894891
    },
    {
        "id": "0c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141038",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Merlina 20 ",
        "postalCode": "41700",
        "lat": 37.2810042,
        "lng": -5.991836999999999
    },
    {
        "id": "1482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1146105",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.11",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.11",
        "surfaceTotal": "180.11",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Cabañal 4 ",
        "lat": 39.1642848,
        "lng": -0.2460687
    },
    {
        "id": "0882e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1129042",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "159.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "159.88",
        "surfaceTotal": "159.88",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Urbano Pineda s/n ",
        "postalCode": "29100",
        "lat": 36.6611779,
        "lng": -4.7551085
    },
    {
        "id": "3082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "174.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "174.00",
        "surfaceTotal": "174.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Benizalon ",
        "postalCode": "04007",
        "lat": 37.212213,
        "lng": -2.2411956
    },
    {
        "id": "2282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Comité",
        "strategy": "ALQUILER",
        "city": "1119130",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "202.81",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.81",
        "surfaceTotal": "202.81",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Del Ejercito 11 ",
        "postalCode": "19004",
        "lat": 40.6322013,
        "lng": -3.1756518
    },
    {
        "id": "1682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1107014",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "182.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.69",
        "surfaceTotal": "182.69",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Orient S/N ",
        "postalCode": "07580",
        "lat": 39.7021506,
        "lng": 3.43403
    },
    {
        "id": "4082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1127028",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "26.67",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "198.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "257.00",
        "surfaceTotal": "374.67",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Quiroga 4 ",
        "postalCode": "27004",
        "lat": 43.0130821,
        "lng": -7.5658794
    },
    {
        "id": "1a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1115054",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.80",
        "surfaceTotal": "115.80",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle De Castela 104 ",
        "postalCode": "15578",
        "lat": 43.497601,
        "lng": -8.199752199999999
    },
    {
        "id": "2082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128065",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.30",
        "surfaceTotal": "286.30",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Madrid 92 ",
        "postalCode": "28902",
        "lat": 40.3082504,
        "lng": -3.7323934
    },
    {
        "id": "1282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103065",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.24",
        "surfaceTotal": "140.24",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Diagonal 29 ",
        "postalCode": "03206",
        "lat": 38.2699329,
        "lng": -0.7125608
    },
    {
        "id": "f281e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1148017",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "30.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "194.69",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.69",
        "surfaceTotal": "224.69",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Santamañe 3 ",
        "postalCode": "48370",
        "lat": 43.4179804,
        "lng": -2.723668
    },
    {
        "id": "2882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111020",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "103.59",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "241.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.09",
        "surfaceTotal": "344.59",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Larga 18 ",
        "postalCode": "11004",
        "lat": 36.68366,
        "lng": -6.136489999999999
    },
    {
        "id": "3682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "170.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "85.00",
        "surfaceTotal": "170.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Mariano Andres 182 ",
        "postalCode": "24008",
        "lat": 42.6153355,
        "lng": -5.5684144
    },
    {
        "id": "2c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1148054",
        "province": "48",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "smokeStractor": true,
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "125.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "55.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "152.50",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Jose Ramon Aketxe 5 ",
        "postalCode": "48940",
        "lat": 43.3258801,
        "lng": -2.9864402
    },
    {
        "id": "2a82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1131157",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Nave industrial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "98.70",
        "surfaceTotal": "98.70",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Diputacion Foral 8 ",
        "postalCode": "31580",
        "lat": 42.4226679,
        "lng": -2.0791952
    },
    {
        "id": "4882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130902",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "147.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "147.00",
        "surfaceTotal": "147.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Libertad ",
        "postalCode": "30710",
        "lat": 37.7429881,
        "lng": -0.8500143
    },
    {
        "id": "4482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136024",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.00",
        "surfaceTotal": "189.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Puente 4 ",
        "postalCode": "36500",
        "lat": 42.6611505,
        "lng": -8.1110256
    },
    {
        "id": "2e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128074",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.40",
        "surfaceTotal": "166.40",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Rio Duero 46 ",
        "postalCode": "28913",
        "lat": 40.3353441,
        "lng": -3.7705233
    },
    {
        "id": "0682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128049",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.92",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.92",
        "surfaceTotal": "166.92",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Puerto De Barcelona ",
        "postalCode": "28821",
        "lat": 40.4194596,
        "lng": -3.5722344
    },
    {
        "id": "4a7fe90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1129068",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "192.47",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "192.47",
        "surfaceTotal": "192.47",
        "timeAvailableFrom": "9/13/22 13:23",
        "address": "Carretera Nacional-340 km146 ",
        "postalCode": "29692",
        "lat": 37.9752754,
        "lng": -1.2368537
    },
    {
        "id": "4a82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "96.59",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "102.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "79.98",
        "surfaceTotal": "198.59",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Torre Arias 6 ",
        "postalCode": "28022",
        "lat": 40.4459882,
        "lng": -3.6120582
    },
    {
        "id": "4282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1108105",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "185.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "104.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "237.00",
        "surfaceTotal": "289.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Onze De Setembre 33 ",
        "postalCode": "08120",
        "lat": 41.512476,
        "lng": 2.1922326
    },
    {
        "id": "3e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1127028",
        "province": "27",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "110.97",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "110.97",
        "surfaceTotal": "110.97",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Plaza Fonte Dos Ranchos 6 ",
        "postalCode": "27004",
        "lat": 43.01298,
        "lng": -7.565399999999999
    },
    {
        "id": "1c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1138017",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "53.30",
        "surfaceMezzanine": "0.00",
        "surfacepb": "150.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "137.12",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "234.55",
        "surfaceTotal": "340.42",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Santa Cruz 121 ",
        "postalCode": "38611",
        "lat": 28.0762229,
        "lng": -16.5570951
    },
    {
        "id": "3282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "189.10",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.10",
        "surfaceTotal": "189.10",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Granada 131 ",
        "postalCode": "04009",
        "lat": 36.834047,
        "lng": -2.4637136
    },
    {
        "id": "3c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1121044",
        "province": "21",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "290.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "290.00",
        "surfaceTotal": "290.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Blas Infante s/n ",
        "postalCode": "21440",
        "lat": 37.2515747,
        "lng": -7.2065574
    },
    {
        "id": "1e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Oficina",
        "surfacebr": "34.97",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "460.46",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "240.72",
        "surfaceTotal": "495.43",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Jose Luis Perez Pujada 7 ",
        "postalCode": "18006",
        "lat": 37.1604092,
        "lng": -3.6077322
    },
    {
        "id": "3a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "104.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "104.00",
        "surfaceTotal": "104.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Jose Maria Fernandez 42 ",
        "postalCode": "24006",
        "lat": 42.5986475,
        "lng": -5.5616746
    },
    {
        "id": "3482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104013",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.27",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.27",
        "surfaceTotal": "158.27",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Cabo de Gata 141 ",
        "postalCode": "04007",
        "lat": 36.8268352,
        "lng": -2.449403
    },
    {
        "id": "4682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1135016",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "560.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "560.00",
        "surfaceTotal": "560.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Juan Rejon 95 ",
        "postalCode": "35008",
        "lat": 28.1495929,
        "lng": -15.4244147
    },
    {
        "id": "3882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "175.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "175.12",
        "surfaceTotal": "175.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Jose Maria De Pereda 15 ",
        "postalCode": "24006",
        "lat": 42.5915999,
        "lng": -5.5618715
    },
    {
        "id": "5082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.94",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.94",
        "surfaceTotal": "215.94",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Santa Virgilia 21 ",
        "postalCode": "28033",
        "lat": 40.47670979999999,
        "lng": -3.6405177
    },
    {
        "id": "4e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "160.00",
        "surfaceTotal": "224.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Carretera De Canillas 140 ",
        "postalCode": "28043",
        "lat": 40.4650517,
        "lng": -3.6392157
    },
    {
        "id": "2482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104052",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.98",
        "surfaceTotal": "161.98",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Real 37 ",
        "postalCode": "04230",
        "lat": 36.8881816,
        "lng": -2.4445519
    },
    {
        "id": "4c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "CAMBIO DE USO",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "76.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "76.00",
        "surfaceTotal": "76.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De La Osa Mayor 85 ",
        "postalCode": "28023",
        "lat": 40.459037,
        "lng": -3.7837053
    },
    {
        "id": "6a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1129069",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "209.30",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "209.30",
        "surfaceTotal": "209.30",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Ricardo Soriano 52 ",
        "postalCode": "29601",
        "lat": 36.5107382,
        "lng": -4.8940898
    },
    {
        "id": "5282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "347.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "356.12",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "460.22",
        "surfaceTotal": "703.12",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Francisco Silvela 46 ",
        "postalCode": "28028",
        "lat": 40.43398639999999,
        "lng": -3.673423
    },
    {
        "id": "6682e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "ALQUILER",
        "city": "1123059",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "131.34",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "131.34",
        "surfaceTotal": "131.34",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Orti Lara 4 ",
        "postalCode": "23770",
        "lat": 38.0445283,
        "lng": -4.1701941
    },
    {
        "id": "5a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "565.39",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "565.39",
        "surfaceTotal": "565.39",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Lopez De Hoyos 135-137 ",
        "postalCode": "28079",
        "lat": 40.4471346,
        "lng": -3.6698059
    },
    {
        "id": "5e82e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1131163",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "87.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "87.00",
        "surfaceTotal": "87.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Ana De Velasco 5 ",
        "postalCode": "31340",
        "lat": 42.3271295,
        "lng": -1.7393763
    },
    {
        "id": "5482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "324.25",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "162.13",
        "surfaceTotal": "324.25",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Valderribas 72 ",
        "postalCode": "28007",
        "lat": 40.4019916,
        "lng": -3.6701748
    },
    {
        "id": "5682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "115.23",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "115.23",
        "surfaceTotal": "115.23",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Gran Via de Hortaleza 59 ",
        "postalCode": "28004",
        "lat": 40.4690049,
        "lng": -3.64551
    },
    {
        "id": "6282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1130030",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "112.60",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "112.60",
        "surfaceTotal": "112.60",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida Abenarabi 4 ",
        "postalCode": "30008",
        "lat": 37.9964158,
        "lng": -1.1327857
    },
    {
        "id": "6c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108118",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "163.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "133.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.07",
        "surfaceTotal": "296.57",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Plaza Marcelina De Monteys 5 ",
        "lat": 41.4826455,
        "lng": 2.3114706
    },
    {
        "id": "6082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1124157",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.00",
        "surfaceTotal": "186.00",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Cirilo Santos 21 ",
        "postalCode": "24240",
        "lat": 42.3528511,
        "lng": -5.7542094
    },
    {
        "id": "7e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "city": "1118153",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "166.01",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "166.01",
        "surfaceTotal": "166.01",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida De Asegra ",
        "postalCode": "18210",
        "lat": 37.2235049,
        "lng": -3.6265043
    },
    {
        "id": "7682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120063",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "196.32",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "196.32",
        "surfaceTotal": "196.32",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Astiigarrako Bidea 1 ",
        "postalCode": "20180",
        "lat": 43.2993676,
        "lng": -1.8815009
    },
    {
        "id": "d082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "2368.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2368.00",
        "surfaceTotal": "2368.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "9082e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1123006",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "140.46",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "140.46",
        "surfaceTotal": "140.46",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Damian Parras 4 ",
        "postalCode": "23760",
        "lat": 37.93681,
        "lng": -4.05649
    },
    {
        "id": "7882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1132054",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "203.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "203.00",
        "surfaceTotal": "203.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida De Zamora 61 ",
        "postalCode": "32005",
        "lat": 42.325413,
        "lng": -7.8629984
    },
    {
        "id": "8a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "ALQUILER",
        "city": "1123069",
        "province": "23",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Carretera De Jesus 18 ",
        "postalCode": "23790",
        "lat": 37.8698808,
        "lng": -4.1846569
    },
    {
        "id": "7a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1133044",
        "province": "33",
        "CCAA": "31",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "155.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "155.00",
        "surfaceTotal": "155.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Carretera General 136 ",
        "postalCode": "33010",
        "lat": 43.3785719,
        "lng": -5.7933356
    },
    {
        "id": "7082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1135003",
        "province": "35",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "111.08",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "111.08",
        "surfaceTotal": "111.08",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Urbanización El Castillo ",
        "postalCode": "35630",
        "lat": 14.5572969,
        "lng": -90.73322329999999
    },
    {
        "id": "5882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "221.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "221.53",
        "surfaceTotal": "221.53",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " Hermanos Garcia Noblejas 18-20 ",
        "postalCode": "28037",
        "lat": 40.43548759999999,
        "lng": -3.6366165
    },
    {
        "id": "9682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1134157",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "148.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "148.00",
        "surfaceTotal": "148.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida De Jose Quintana 2 ",
        "postalCode": "34100",
        "lat": 42.5221381,
        "lng": -4.7373332
    },
    {
        "id": "a482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "222.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "222.00",
        "surfaceTotal": "222.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Poligono Ind. Parsi ",
        "postalCode": "41020",
        "lat": 37.3778056,
        "lng": -5.9193871
    },
    {
        "id": "a282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "SINGULARES",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "555.18",
        "surfaceMezzanine": "0.00",
        "surfacepb": "894.40",
        "surfaceBasement1": "724.00",
        "surfaceBasement2": "716.40",
        "surfaceRest": "712.00",
        "surfacesr": "2152.40",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "546.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2137.15",
        "surfaceTotal": "3601.98",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Garcia De Vinuesa 10 ",
        "postalCode": "41001",
        "lat": 37.3866607,
        "lng": -5.9944886
    },
    {
        "id": "8882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1107560",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "212.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "36.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "128.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "163.60",
        "surfaceTotal": "376.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Joan Servera Camp 20 ",
        "postalCode": "07560",
        "lat": 39.603833,
        "lng": 3.3844639
    },
    {
        "id": "9a82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1119257",
        "province": "19",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Cardenal Mendoza 17 ",
        "postalCode": "19250",
        "lat": 41.0678503,
        "lng": -2.6428906
    },
    {
        "id": "8282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.55",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.55",
        "surfaceTotal": "176.55",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Amilcar 8 ",
        "postalCode": "07600",
        "lat": 39.5061208,
        "lng": 2.7526303
    },
    {
        "id": "8682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1131201",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.87",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.87",
        "surfaceTotal": "215.87",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Marcelo Celayeta 72 ",
        "postalCode": "31014",
        "lat": 42.8280129,
        "lng": -1.6485522
    },
    {
        "id": "8e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1109321",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "40.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "170.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "182.00",
        "surfaceTotal": "210.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Plaza Mayor 28 ",
        "postalCode": "09300",
        "lat": 40.4158346,
        "lng": -3.7071805
    },
    {
        "id": "7c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1134120",
        "province": "34",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "61.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "361.00",
        "surfaceBasement1": "132.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "132.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "61.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "445.30",
        "surfaceTotal": "554.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " La Cestilla 2 ",
        "postalCode": "34001",
        "lat": 42.00971,
        "lng": -4.5334763
    },
    {
        "id": "6882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1130027",
        "province": "30",
        "CCAA": "43",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "151.37",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "151.37",
        "surfaceTotal": "151.37",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Carretera Madrid Cartagena 381 ",
        "postalCode": "30500",
        "lat": 38.048026,
        "lng": -1.2117416
    },
    {
        "id": "9282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1143123",
        "province": "43",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "130.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "130.71",
        "surfaceTotal": "130.71",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Teresa Pamies ",
        "postalCode": "43204",
        "lat": 41.1498259,
        "lng": 1.1055321
    },
    {
        "id": "b682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "SINGULARES",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "295.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "859.00",
        "surfaceBasement1": "291.00",
        "surfaceBasement2": "995.00",
        "surfaceRest": "1507.00",
        "surfacesr": "2793.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "295.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2344.00",
        "surfaceTotal": "3947.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Policarpo Sanz 23 ",
        "postalCode": "36202",
        "lat": 42.2377456,
        "lng": -8.721668600000001
    },
    {
        "id": "6e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1138024",
        "province": "38",
        "CCAA": "56",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.71",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.71",
        "surfaceTotal": "156.71",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida De Enrique Mederos 20 ",
        "postalCode": "38760",
        "lat": 28.6597398,
        "lng": -17.914911
    },
    {
        "id": "ae82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - En legal",
        "strategy": "VENTA",
        "city": "1131243",
        "province": "31",
        "CCAA": "11",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "121.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "121.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "181.50",
        "surfaceTotal": "242.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Plaza Del Ferial 34 ",
        "postalCode": "31420",
        "lat": 42.777709,
        "lng": -1.4589319
    },
    {
        "id": "9e82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108240",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "193.26",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.26",
        "surfaceTotal": "193.26",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Raval 31 ",
        "postalCode": "08770",
        "lat": 41.4239735,
        "lng": 1.7841296
    },
    {
        "id": "a682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "135.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "135.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Guadalajara (Alonso Mingo-Bellavista) ",
        "postalCode": "41014",
        "lat": 37.3221374,
        "lng": -5.9659406
    },
    {
        "id": "aa82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1129901",
        "province": "29",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "123.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "123.00",
        "surfaceTotal": "123.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Bulto 20 ",
        "postalCode": "29620",
        "lat": 36.6102965,
        "lng": -4.5036486
    },
    {
        "id": "8482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "CAMBIO DE USO",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "144.98",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "144.98",
        "surfaceTotal": "144.98",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Plaza Miquel Dolç 1 ",
        "postalCode": "07008",
        "lat": 39.576622,
        "lng": 2.668205
    },
    {
        "id": "7282e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "176.65",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "176.65",
        "surfaceTotal": "176.65",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Ingeniero J. De La Cierva s/n ",
        "postalCode": "14013",
        "lat": 37.8881751,
        "lng": -4.7793835
    },
    {
        "id": "8082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1107040",
        "province": "07",
        "CCAA": "44",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Francesç Marti I Mora ",
        "postalCode": "07011",
        "lat": 39.5834294,
        "lng": 2.6370595
    },
    {
        "id": "9882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1111031",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Real 22 ",
        "postalCode": "11100",
        "lat": 36.46650950000001,
        "lng": -6.195422199999999
    },
    {
        "id": "b482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1132085",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "80.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "91.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "125.50",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Luis Espada 43 ",
        "postalCode": "32600",
        "lat": 41.9402367,
        "lng": -7.4379209
    },
    {
        "id": "6482e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1113052",
        "province": "13",
        "CCAA": "40",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.88",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.88",
        "surfaceTotal": "96.88",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": " La Tercia 61 ",
        "postalCode": "13420",
        "lat": 39.1668064,
        "lng": -3.853225
    },
    {
        "id": "f282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1109059",
        "province": "09",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "379.13",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "189.57",
        "surfaceTotal": "379.13",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Maria De Zayas Plaza 11 ",
        "postalCode": "09001",
        "lat": 42.3273055,
        "lng": -3.6985778
    },
    {
        "id": "b082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1120073",
        "province": "20",
        "CCAA": "53",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "161.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "161.90",
        "surfaceTotal": "161.90",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Mayor 6 y 8 ",
        "postalCode": "20170",
        "lat": 43.2714405,
        "lng": -2.0498543
    },
    {
        "id": "ac82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1141093",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "156.45",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "156.45",
        "surfaceTotal": "156.45",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida De La Arboleda s/n ",
        "postalCode": "41940",
        "lat": 37.3733763,
        "lng": -6.0394403
    },
    {
        "id": "b282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1108136",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "158.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "158.35",
        "surfaceTotal": "158.35",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida Onze De Setembre 16 ",
        "postalCode": "08170",
        "lat": 41.5434195,
        "lng": 2.2649724
    },
    {
        "id": "bc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1137364",
        "province": "37",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "57.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "57.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "57.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "102.60",
        "surfaceTotal": "171.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Plaza Mayor 18 ",
        "postalCode": "37160",
        "lat": 40.4153281,
        "lng": -3.7082971
    },
    {
        "id": "a082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1108263",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "180.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "180.00",
        "surfaceTotal": "180.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Mosen Jacinto Verdaguer, 122 ",
        "postalCode": "08620",
        "lat": 41.3969203,
        "lng": 2.0081523
    },
    {
        "id": "d482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1132025",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "114.54",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "114.54",
        "surfaceTotal": "114.54",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Carretera de Vigo 25 ",
        "postalCode": "321450",
        "lat": 42.3208853,
        "lng": -7.8800601
    },
    {
        "id": "f882e90a-5633-ed11-9db1-0022489c4873",
        "active": false,
        "status": "Vendido",
        "strategy": "VENTA",
        "city": "1128006",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "146.24",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "146.24",
        "surfaceTotal": "146.24",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida España 15 ",
        "postalCode": "28100",
        "lat": 40.5482918,
        "lng": -3.6403653
    },
    {
        "id": "9c82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115635",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "266.44",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "266.44",
        "surfaceTotal": "266.44",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida Malecon 25 ",
        "postalCode": "15960",
        "lat": 42.5541748,
        "lng": -8.989874799999999
    },
    {
        "id": "f482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "57.14",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "57.14",
        "surfaceTotal": "57.14",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida Villajoyosa ",
        "postalCode": "03502",
        "lat": 38.6005665,
        "lng": -0.1357372
    },
    {
        "id": "9482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115078",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "162.51",
        "surfaceMezzanine": "0.00",
        "surfacepb": "769.17",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "310.58",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "973.21",
        "surfaceTotal": "1242.26",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Rua Da Fonte De Santo Antonio 21 ",
        "postalCode": "15702",
        "lat": 42.8769458,
        "lng": -8.5437164
    },
    {
        "id": "be82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1136060",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "98.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "241.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "218.50",
        "surfaceTotal": "339.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Plaza De Galicia 7 ",
        "postalCode": "36600",
        "lat": 42.59541919999999,
        "lng": -8.7656036
    },
    {
        "id": "46845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.74",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.74",
        "surfaceTotal": "186.74",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "c282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Terciario",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "324.90",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "324.90",
        "surfaceTotal": "324.90",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Tierra De Medina 5 ",
        "postalCode": "47008",
        "lat": 41.6193578,
        "lng": -4.7490384
    },
    {
        "id": "f682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1103031",
        "province": "03",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "94.96",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.96",
        "surfaceTotal": "94.96",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Partida La Cala ",
        "postalCode": "03502",
        "lat": 38.5234756,
        "lng": -0.1691137
    },
    {
        "id": "d282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1149275",
        "province": "49",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "226.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "226.00",
        "surfaceTotal": "226.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Feria 3 ",
        "postalCode": "49004",
        "lat": 41.5034712,
        "lng": -5.7467879
    },
    {
        "id": "ca82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "strategy": "ALQUILER",
        "city": "1150297",
        "province": "50",
        "CCAA": "10",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "150.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "75.00",
        "surfaceTotal": "150.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Carretera De Logroño 48-50-52 ",
        "postalCode": "50620",
        "lat": 41.7190642,
        "lng": -1.0282995
    },
    {
        "id": "f07de90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Vivienda",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "0.00",
        "surfaceTotal": "0.00",
        "timeAvailableFrom": "9/13/22 13:22",
        "address": " Michelena 26 ",
        "postalCode": "36002",
        "lat": 42.431316,
        "lng": -8.6456312
    },
    {
        "id": "a882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1117164",
        "province": "17",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "283.57",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "283.57",
        "surfaceTotal": "283.57",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Montsolis 1 ",
        "postalCode": "17403",
        "lat": 41.8797349,
        "lng": 2.5089246
    },
    {
        "id": "c682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1125254",
        "province": "25",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "72.92",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "72.92",
        "surfaceTotal": "72.92",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Gran Via SN ",
        "postalCode": "25690",
        "lat": 41.6896179,
        "lng": 0.7278493
    },
    {
        "id": "b882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "439.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "439.00",
        "surfaceTotal": "439.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Venezuela 34 ",
        "postalCode": "36203",
        "lat": 42.24059889999999,
        "lng": -8.7207268
    },
    {
        "id": "58845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "74.95",
        "surfaceBasement1": "74.95",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "74.95",
        "surfaceTotal": "74.95",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "lat": 37.4729709,
        "lng": -4.4440773
    },
    {
        "id": "fa82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Oficina",
        "surfacebr": "272.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "243.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "272.80",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "325.66",
        "surfaceTotal": "516.62",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Nuñez De Balboa 56 ",
        "postalCode": "28001",
        "lat": 40.4285843,
        "lng": -3.6823934
    },
    {
        "id": "c882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1115054",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "163.62",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "130.10",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "228.67",
        "surfaceTotal": "293.72",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida Do Xubia 15 ",
        "postalCode": "15570",
        "lat": 43.516211,
        "lng": -8.1506487
    },
    {
        "id": "3e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "lat": 41.3681349,
        "lng": 2.1297714
    },
    {
        "id": "7a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "98.74",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "49.37",
        "surfaceTotal": "98.74",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Mallorca 547 ",
        "lat": 41.409747,
        "lng": 2.1835645
    },
    {
        "id": "54845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "No comercializable - Alquilado - Arrendado (propiedad)",
        "city": "1111004",
        "province": "11",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "270.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "270.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "135.00",
        "surfaceTotal": "270.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Plaza Alta 12 ",
        "postalCode": "11201",
        "lat": 36.1307875,
        "lng": -5.447254
    },
    {
        "id": "e282e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108019",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "81.77",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "40.89",
        "surfaceTotal": "81.77",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Paseo De Valldaura 212 ",
        "postalCode": "08042",
        "lat": 41.4384129,
        "lng": 2.1727764
    },
    {
        "id": "d882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1124089",
        "province": "24",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "287.79",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "411.97",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "292.32",
        "surfaceTotal": "699.76",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Independencia 6 ",
        "postalCode": "24001",
        "lat": 42.5959597,
        "lng": -5.5710184
    },
    {
        "id": "da82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1141091",
        "province": "41",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "201.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "201.40",
        "surfaceTotal": "201.40",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Pages Del Corro 79 ",
        "postalCode": "41010",
        "lat": 37.383313,
        "lng": -6.0043666
    },
    {
        "id": "dc82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1140076",
        "province": "40",
        "CCAA": "59",
        "country": "ES",
        "use": "Centro Formación",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "548.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "274.00",
        "surfaceTotal": "548.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Fuentecillas 8 ",
        "postalCode": "40410",
        "lat": 40.7339528,
        "lng": -4.1866376
    },
    {
        "id": "c482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1147186",
        "province": "47",
        "CCAA": "59",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "323.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "323.80",
        "surfaceTotal": "323.80",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Santa Lucia 19 ",
        "postalCode": "47004",
        "lat": 41.6504505,
        "lng": -4.7164699
    },
    {
        "id": "d682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1115053",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "96.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "96.00",
        "surfaceTotal": "96.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Ribeira Ribeira de Maio 2 ",
        "postalCode": "15240",
        "lat": 42.7914625,
        "lng": -8.988729600000001
    },
    {
        "id": "e682e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Nave industrial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "286.53",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "286.53",
        "surfaceTotal": "286.53",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Gándara 8 ",
        "postalCode": "36619",
        "lat": 42.1644134,
        "lng": -8.7180884
    },
    {
        "id": "f082e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1136038",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "91.50",
        "surfaceMezzanine": "0.00",
        "surfacepb": "128.40",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "66.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "188.85",
        "surfaceTotal": "285.90",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Plaza Peregrina 50 ",
        "postalCode": "36001",
        "lat": 42.4308514,
        "lng": -8.644010399999999
    },
    {
        "id": "ce82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1118087",
        "province": "18",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "87.65",
        "surfaceMezzanine": "0.00",
        "surfacepb": "225.31",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "73.16",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "288.19",
        "surfaceTotal": "386.12",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Isabel La Catolica, 2 ",
        "postalCode": "18009",
        "lat": 37.1751959,
        "lng": -3.5976027
    },
    {
        "id": "ec82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1115019",
        "province": "15",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "173.35",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "173.35",
        "surfaceTotal": "173.35",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Barcelona 10 12 ",
        "postalCode": "15100",
        "lat": 41.3873974,
        "lng": 2.168568
    },
    {
        "id": "ce81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1132032",
        "province": "32",
        "CCAA": "60",
        "country": "ES",
        "use": "Almacén",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "132.26",
        "surfaceBasement2": "57.03",
        "surfaceRest": "0.00",
        "surfacesr": "189.29",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "94.65",
        "surfaceTotal": "189.29",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Avenida De Madrid 16 ",
        "postalCode": "32630",
        "lat": 42.0622372,
        "lng": -7.7244213
    },
    {
        "id": "68845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "124.09",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "124.09",
        "surfaceTotal": "124.09",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Rincon De Ademuz 29 ",
        "postalCode": "46018",
        "lat": 39.47061009999999,
        "lng": -0.402506
    },
    {
        "id": "cc81e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "98.63",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "98.63",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "49.32",
        "surfaceTotal": "98.63",
        "timeAvailableFrom": "9/13/22 13:24",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "lat": 37.6979035,
        "lng": -5.2821294
    },
    {
        "id": "6a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1128079",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "308.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "154.00",
        "surfaceTotal": "308.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Francisco Silvela 46 ",
        "postalCode": "28028",
        "lat": 40.43398639999999,
        "lng": -3.673423
    },
    {
        "id": "ee82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136060",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "239.82",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "239.82",
        "surfaceTotal": "239.82",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Ramon y Cajal 2 ",
        "postalCode": "36600",
        "lat": 42.5961673,
        "lng": -8.765377899999999
    },
    {
        "id": "ea82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1104079",
        "province": "04",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "224.25",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "224.25",
        "surfaceTotal": "224.25",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Residencial Al- Baida Pueblo Arabe ",
        "postalCode": "04740",
        "lat": 36.7284193,
        "lng": -2.6230286
    },
    {
        "id": "6c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "24.72",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.42",
        "surfaceTotal": "24.72",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "ba82e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1136057",
        "province": "36",
        "CCAA": "60",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "200.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "200.00",
        "surfaceTotal": "200.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Avenida De La Florida 47 ",
        "postalCode": "36210",
        "lat": 42.218136,
        "lng": -8.736222099999999
    },
    {
        "id": "e482e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1128047",
        "province": "28",
        "CCAA": "54",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "103.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "171.22",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "202.36",
        "surfaceTotal": "275.02",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": " Real 31 ",
        "postalCode": "28400",
        "lat": 40.6308775,
        "lng": -4.0055605
    },
    {
        "id": "e882e90a-5633-ed11-9db1-0022489c4873",
        "active": true,
        "status": "Comercializable",
        "strategy": "VENTA",
        "city": "1108121",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "2796.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "2796.00",
        "surfaceTotal": "2796.00",
        "timeAvailableFrom": "9/13/22 13:25",
        "address": "Calle Carrasco I Formiguera ",
        "postalCode": "08302",
        "lat": 41.5323575,
        "lng": 2.4270995
    },
    {
        "id": "48845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "10.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.24",
        "surfaceTotal": "10.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "40845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "lat": 41.3681349,
        "lng": 2.1297714
    },
    {
        "id": "5c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "93.34",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "93.34",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "46.67",
        "surfaceTotal": "93.34",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "lat": 37.6979035,
        "lng": -5.2821294
    },
    {
        "id": "6e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "29.02",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "8.71",
        "surfaceTotal": "29.02",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "4a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "186.70",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "186.70",
        "surfaceTotal": "186.70",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "64845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "63.90",
        "surfaceBasement1": "63.90",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "63.90",
        "surfaceTotal": "63.90",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "lat": 37.4729709,
        "lng": -4.4440773
    },
    {
        "id": "42845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "lat": 41.3681349,
        "lng": 2.1297714
    },
    {
        "id": "5e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "87.75",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "87.75",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "43.88",
        "surfaceTotal": "87.75",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "lat": 37.6979035,
        "lng": -5.2821294
    },
    {
        "id": "70845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "28.31",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "8.49",
        "surfaceTotal": "28.31",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "4c845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "215.26",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "215.26",
        "surfaceTotal": "215.26",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "66845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114013",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "32.97",
        "surfaceBasement1": "32.97",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "32.97",
        "surfaceTotal": "32.97",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Jose Solis Ruiz 35 ",
        "postalCode": "14940",
        "lat": 37.4729709,
        "lng": -4.4440773
    },
    {
        "id": "60845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "strategy": "ALQUILER",
        "city": "1114049",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "78.15",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "78.15",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "39.08",
        "surfaceTotal": "78.15",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Ancha 4 ",
        "postalCode": "14700",
        "lat": 37.6979035,
        "lng": -5.2821294
    },
    {
        "id": "44845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "41.80",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "12.54",
        "surfaceTotal": "41.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "lat": 41.3681349,
        "lng": 2.1297714
    },
    {
        "id": "72845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "26.25",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.88",
        "surfaceTotal": "26.25",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "4e845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "244.27",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "244.27",
        "surfaceTotal": "244.27",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "5a845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "No comercializable - Alquilado - Subarrendado (gestión)",
        "city": "1108101",
        "province": "08",
        "CCAA": "55",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "97.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "164.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "193.10",
        "surfaceTotal": "261.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Marti I Codolar, 39 - 41 ",
        "postalCode": "08902",
        "lat": 41.3681349,
        "lng": 2.1297714
    },
    {
        "id": "74845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "20.88",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "6.26",
        "surfaceTotal": "20.88",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "50845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "306.80",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "306.80",
        "surfaceTotal": "306.80",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "76845e94-6233-ed11-9db1-0022489ca4d1",
        "active": false,
        "status": "Vendido",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "23.57",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "7.07",
        "surfaceTotal": "23.57",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    },
    {
        "id": "52845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1146250",
        "province": "46",
        "CCAA": "42",
        "country": "ES",
        "use": "Parking",
        "surfacebr": "10.35",
        "surfaceMezzanine": "0.00",
        "surfacepb": "0.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "3.10",
        "surfaceTotal": "10.35",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Avenida Instituto Obrero Valencia 23 ",
        "postalCode": "46002",
        "lat": 39.4559482,
        "lng": -0.3576652
    },
    {
        "id": "78845e94-6233-ed11-9db1-0022489ca4d1",
        "active": true,
        "status": "Comercializable",
        "city": "1114021",
        "province": "14",
        "CCAA": "51",
        "country": "ES",
        "use": "Local comercial",
        "surfacebr": "0.00",
        "surfaceMezzanine": "0.00",
        "surfacepb": "680.00",
        "surfaceBasement1": "0.00",
        "surfaceBasement2": "0.00",
        "surfaceRest": "0.00",
        "surfacesr": "0.00",
        "surfaceBasement": "0.00",
        "surfaceFloor1": "0.00",
        "surfaceFloor2": "0.00",
        "surfaceWeighted": "680.00",
        "surfaceTotal": "680.00",
        "timeAvailableFrom": "9/13/22 14:50",
        "address": "Calle Antonio Gaudí 6 ",
        "postalCode": "14005",
        "lat": 37.8876537,
        "lng": -4.7884569
    }
]